import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import saveAs from 'file-saver';
import { useNavigate } from 'react-router-dom'
import voucherwork from "./voucherwork";
import cssclass from "./cssclass";

//var dateFormat = require('dateformat');


const RenderLcrprocess = () => {
var md5 = require('md5');
const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const resturl=sessionStorage.getItem("RESTURL")
const scansurl=sessionStorage.getItem("SCANSURL");	
//const resturl="http://127.0.0.1:3001/";//sessionStorage.getItem("RESTURL")
//const resturl='https://borderforceapps.gov.tc/';

//var boolFetchingSads=false;
let show = true, listener=false;
const navigate = useNavigate();





const [wptapp, setWptapp] = useState({IPM_LBR_CLR_APP_ID:0, RETURN_CLICKED:false});
const [searchcrit, setSearchcrit] = useState({
	txt:""
	, office: ""
	, dates: ""
	, appstatus:""
	, apptype:""
	, filteruser:""
	, reqboardapprov:""
	, intel:""
	, endorsement:""
	});

const [tblendorsee, setTblendorsee] = useState([]);
//const [wrkpmtstatusrows, setWrkpmtstatusrows] = useState([]);
const [tblwrkpmt, setTblwrkpmt] = useState({aps:[], ipm:[]});

const [dowait, setDowait] = useState({show:false});
const [dlwait, setDlwait] = useState({show:false});
const [latedlwait, setLatedlwait] = useState({show:false});

const [dowaittbl, setDowaittbl] = useState({show:false});
const [workpermit, setWorkpermit] = useState({id:0});
const [cbwrkpmtdetail, setCbwrkpmtdetail] = useState({checked:false});


const [combosearchresapps, setCombosearchresapps] = useState([]);
const [tbludakwp, setTbludakwp] = useState([]);
const [udak, setUdak] = useState([]);
const [numcomments, setNumcomments] = useState({lc:0, wp:0});
const [vchroptions, setVchroptions] = useState({switchmpr:0,latefee:0,vchrtype:'WP'});

const [btnreturn, setBtnreturn] = useState({clicked:false});
const [cbbalrcp, setCbbalrcp] = useState({checked:false});

const [city, setCity] = useState({name:""});
const [selectedFiles, setSelectedFiles] = useState([]);
const [combotype, setCombotype] = useState([]);
const [wptprocstatus, setWptprocstatus] = useState([]);
const [tblworkpermits, setTblworkpermits] = useState([]);
const [pastmonths, setPastmonths] = useState([]);
const [tbldocno, setTbldocno] = useState([]);
const [arrsearchdocs, setArrsearchdocs] = useState([]);
const [tbllbrclrdecision, setTbllbrclrdecision] = useState([]);

const [docsearchcrit, setDocsearchcrit] = useState({date:""});

const [arrdecidtostatusid, setArrdecidtostatusid] = useState([
{dec_id:1, status_id:10}
,{dec_id:2, status_id:1}
,{dec_id:3, status_id:2}
,{dec_id:4, status_id:3}
,{dec_id:5, status_id:4}
,{dec_id:6, status_id:11}
,{dec_id:7, status_id:5}
,{dec_id:8, status_id:9}
]);


const [tblvoucher, setTblvoucher] = useState([]);
const [arrdocno, setArrdocno] = useState(["",""]);
//const [combocategory, setCombocategory] = useState([]);
				
const [tbllaborclr, setTbllaborclr] = useState([]);
const [progress, setProgress] = useState({
perct:null
});

//const [timeLeft, setTimeLeft] = useState(null);

const [comboprocessarea, setComboprocessarea] = useState([]);
const [arrcheckbox, setArrcheckbox] = useState([]);

const [laborclrstatus, setLaborclrstatus] = useState([]);
const [combocategory, setCombocategory] = useState([]);
const [arraycomment, setArraycomment] = useState([]);

const [countryoptions, setCountryoptions] = useState([]);
const [agencyoptions, setAgencyoptions] = useState([]);
const [payperiodoptions, setPayperiodoptions] = useState([]);
const [occupationoptions, setOccupationoptions] = useState([]);
const [lcrtypeoptions, setLcrtypeoptions] = useState([]);
const [locationoptions, setLocationoptions] = useState([]);
//const [statusoptions, setLaborclrstatus] = useState([]);
const [reviewtypeoptions, setReviewtypeoptions] = useState([]);
//const [reviewtypeoptions, setSalarysoptions] = useState([]);
const [decisionoptions, setDecisionoptions] = useState([]);
const [cswkrlbrclrlist, setCswkrlbrclrlist] = useState([]);


const [genderoptions, setGenderoptions] = useState([
<option key="gender1" value='Female' >Female</option>
,<option key="gender2" value='Male' >Male</option>
]);

const [yesnooptions, setYesnooptions] = useState([
<option key="yesno1" value='1' >Yes</option>
,<option key="yesno2" value='0' >No</option>
]);



const location = useLocation();
const AD_USER=sessionStorage.getItem("AD_USER")?sessionStorage.getItem("AD_USER"):"";

useEffect(() => {



//console.log("AD_USER: "+AD_USER);
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if	
	
if (AD_USER==""){
	navigate("/dashboard");
	return;
	}//end if	
	
document.title =   "APS Labour Clearance";	
openCity(null, "tbllaborclr");
/*
179207
108763
*/
//getwpformoptions();
const searchresapps=location.state?(location.state.searchresapps??[]):[];
const tempsearchresopts=[];
console.log("searchresapps.length: "+searchresapps.length);
for (var i=0; i<searchresapps.length; i++)
	tempsearchresopts.push(<option value={searchresapps[i]['WPT_APP_ID']} >{searchresapps[i]['SEARCH_RES_ITEM']}</option>);
console.log("tempsearchresopts: "+JSON.stringify(tempsearchresopts));
setCombosearchresapps(tempsearchresopts);

getlcrstartoptions();


 },[]);

useEffect(() => {

if (decisionoptions.length>0 && pastmonths.length==0)
	getpastmonths();

 },[JSON.stringify(decisionoptions)]);


useEffect(() => {

if (pastmonths.length>0 && cswkrlbrclrlist.length==0){
	//getcswkrlbrclrlist();
	setupCheckboxes();
	}//end if
	
 },[JSON.stringify(pastmonths)]);



useEffect(() => {

if (wptapp.WORK_PERMIT_ID>0 && cbwrkpmtdetail.checked==true){
	getwrkpmtdetail( wptapp.WORK_PERMIT_ID);
	}//end if
	
 },[cbwrkpmtdetail.checked, wptapp.WORK_PERMIT_ID]);


useEffect(() => {

if (cbbalrcp.checked==true){
	//cssclass("tblmain", "displaynone", 1);
	if (udak.length==0)
		gettblwptappudak();
	else if (document.getElementsByName('WPAMT[]')[0])
		document.getElementsByName('WPAMT[]')[0].focus();
	}//end func
else{
	//cssclass("tblmain", "displaynone", 0);
	// could not find a way to reload only the vouchers table, so reload entire form
	//getlbrclrorwptapp(wptapp.IPM_LBR_CLR_APP_ID?wptapp.IPM_LBR_CLR_APP_ID:0, wptapp.WPT_APP_ID?wptapp.WPT_APP_ID:0);
	getwptvouchers([]);
	document.getElementById("tblvouchers").scrollIntoView();
	}
	
 },[cbbalrcp.checked]);



useEffect(() => {
/*
after creating receipts, if user ticks cbbalrcp, the old info keyed should be gone
*/
if (tblvoucher.length>0 && cbbalrcp.checked==false)
	gettblwptappudak();

},[JSON.stringify(tblvoucher)]);




useEffect(() => {

if (tbludakwp.length>0){
	if (document.getElementsByName('WPAMT[]')[0])
		document.getElementsByName('WPAMT[]')[0].focus();
	}//end if
//tbludakwp
},[JSON.stringify(tbludakwp)]);

useEffect(() => {
	console.log("useEffect udak.length: "+udak.length);

if (udak.length>0){
	//voucherwork({action:"dosetTbludaklc2"});
	//voucherwork.dosetTbludaklc2();
	dosetTbludaklc();
	}//end if
else{
	setTbludakwp([]);
	//setTbludaklc([]);
	//setTbludakwp([]);
	}//end else
	

},[JSON.stringify(udak)]);

/*
useEffect(() => {
    if(timeLeft===0){
       console.log("TIME LEFT IS 0");
       setTimeLeft(null);
	   tbllbrclrappdecision();
	   return;
    }

    // exit early when we reach 0
    if (!timeLeft) 
		return;

    // save intervalId to clear the interval when the
    // component re-renders
    const intervalId = setInterval(() => {

      setTimeLeft(timeLeft - 1);
    }, 1000);

    // clear interval on re-render to avoid memory leaks
    return () => clearInterval(intervalId);
    // add timeLeft as a dependency to re-rerun the effect
    // when we update it
  }, [timeLeft]);
*/

 
useEffect(() => {
	
//console.log("laborclrstatus: "+JSON.stringify(laborclrstatus));
	//console.log("laborclrstatus.length: "+laborclrstatus.length);
	var WPT_APP_ID=0, IPM_LBR_CLR_APP_ID=0;
	
/*
	if (window.opener)
		if (window.opener.document.getElementsByName("WPT_APP_ID")[0] && WPT_APP_ID==0)
			WPT_APP_ID=window.opener.document.getElementsByName("WPT_APP_ID")[0].value;
*/
		
	if (combocategory.length>0){

	if (location.state){
		
		if (location.state.IPM_LBR_CLR_APP_ID)
			IPM_LBR_CLR_APP_ID=1*location.state.IPM_LBR_CLR_APP_ID
		
		if (location.state.WPT_APP_ID)
			WPT_APP_ID=1*location.state.WPT_APP_ID
		
		}//end if


		if (IPM_LBR_CLR_APP_ID>0)
			setWptapp((prev)=>{
				return {...prev, IPM_LBR_CLR_APP_ID: IPM_LBR_CLR_APP_ID, WPT_APP_ID: WPT_APP_ID, FROM_PREM:false}
			});
		else if (WPT_APP_ID>0)
			setWptapp((prev)=>{
				return {...prev, WPT_APP_ID: WPT_APP_ID, FROM_PREM:false}
			});
		else
			gettbllaborclr();

		}//end if
		

},[JSON.stringify(laborclrstatus)]);
 

useEffect(() => {

console.log("arrsearchdocs.length: "+arrsearchdocs.length);

setTbldocno([]);

if (arrsearchdocs.length>0)
	writetbldocno();

},[JSON.stringify(arrsearchdocs)]);
 

useEffect(() => {

if (wptapp.NEW_DECISION==1)
	updatelbrclrappdecision();

 },[wptapp.NEW_DECISION]);


useEffect(() => {


if (wptapp.PERSON_ID)
	if (wptapp.PERSON_ID>0)
		getworkpermitforperson(wptapp.PERSON_ID);



 },[wptapp.PERSON_ID]);


useEffect(() => {

	checkMedRec();

 },[wptapp.MED_REC]);
 
useEffect(() => {
	
	if (laborclrstatus.length==0)
		return
	
	if (searchcrit.txt.length==0 || searchcrit.txt.length>2)
		gettbllaborclr();
	else
		setTbllaborclr("");

 },[searchcrit]);


useEffect(() => {
	

/*
	console.log("uef: "+docsearchcrit.date);
	
	if (docsearchcrit.date)
		if (docsearchcrit.date!="")
			searchworkervchrs(null);

*/
	
 },[docsearchcrit.date]);

useEffect(() => {

if (tbldocno.length>0)
	cssclass("divdocsearchdate", "hidden", 0);

 },[JSON.stringify(tbldocno)]);
 
useEffect(() => {

//console.log("tbllaborclr.length: "+tbllaborclr.length);


if (tbllaborclr.length>0){
	openCity(null, "tbllaborclr");
	if (document.getElementById('btnclosecb'))
		document.getElementById('btnclosecb').style.visibility="hidden";
	
	setWptapp((prev)=>{
		return {...prev, IPM_LBR_CLR_APP_ID:0}
		});
	
	}//end if
	

 },[JSON.stringify(tbllaborclr)]);


useEffect(() => {

//console.log("arrdocno[0]: "+arrdocno[0]);
//console.log("arrdocno: "+JSON.stringify(arrdocno));
		


 },[JSON.stringify(arrdocno)]);



 
useEffect(() => {
//get_labr_clr_app();
const IPM_LBR_CLR_APP_ID=wptapp.IPM_LBR_CLR_APP_ID??0;
const WPT_APP_ID=wptapp.WPT_APP_ID??0;

if (WPT_APP_ID>0 || IPM_LBR_CLR_APP_ID>0)
	getlbrclrorwptapp(IPM_LBR_CLR_APP_ID, WPT_APP_ID);


/*
if (wptapp.IPM_LBR_CLR_APP_ID>0)	
	getlbrclrorwptapp(wptapp.IPM_LBR_CLR_APP_ID?wptapp.IPM_LBR_CLR_APP_ID:0, wptapp.WPT_APP_ID?wptapp.WPT_APP_ID:0);

*/	

 },[wptapp.IPM_LBR_CLR_APP_ID, wptapp.WPT_APP_ID]);



function checkMedRec(){

console.log("checkMedRec() wptapp.MED_REC: "+wptapp.MED_REC);

	if (wptapp.MED_REC!=undefined && document.getElementsByName('MED_CERT_ISSUE_DATE')[0]){
		const value=wptapp.MED_REC;
		document.getElementsByName('MED_CERT_ISSUE_DATE')[0].required=(value=='1');
		document.getElementsByName('MED_CERT_EXPIRE_DATE')[0].required=(value=='1');

		document.getElementsByName('MED_CERT_ISSUE_DATE')[0].disabled=(value=='0');
		document.getElementsByName('MED_CERT_EXPIRE_DATE')[0].disabled=(value=='0');
		}
	
}//end func
		
function writeCheckboxValue(isChecked, checkboxValue){

showBtnsave();

let strComments = document.getElementById("comboticksresult").value.trim();
console.log("strComments: "+strComments);

if (isChecked==true){
	if (strComments!="")
		strComments+="\r\n";

	strComments+=checkboxValue;
	}
else{
	strComments=strComments.replace("\r\n"+checkboxValue,"");
	strComments=strComments.replace(checkboxValue,"");
	strComments=strComments.replace("\r\n\r\n", "\r\n");
	}

//let temp=wptapp;
//temp.COMMENTS=strComments;
setWptapp((prev)=>{
	return {...prev, COMMENTS:strComments}
	});
//setWptapp(temp);

const cbopts=document.getElementsByName("cbopts");
for (var i=0; i<cbopts.length; i++)
	if (cbopts[i].value!=checkboxValue)
		cbopts[i].checked=false;

/*

setWptapp((prev)=>{
	return {...prev, COMMENTS:strComments}
	});
The below code may be useful in a different scenario to amalgamate all ticked checkboxValues.
curr scenario I just will just append current checkboxValue
*/

if (1<0){
	const resultElem = document.getElementById("comboticksresult");
	const cbopts=document.getElementsByName("cbopts");
	console.log("setresult cbopts.length: "+cbopts.length);
	var result="";
	for (var i=0; i<cbopts.length; i++){
		
		if (cbopts[i].checked===true){
			if (result!="")
				result+="\r\n";
			
			result+=cbopts[i].value;
			}//end if
		
	}//end if
		
}//end for

//resultElem.value=result;

}//end func

function openCity(evt, cityName) {
	
	console.log("openCity: "+cityName);
	
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  if (document.getElementById(cityName))
	document.getElementById(cityName).style.display = "block";

/*
	if (evt.currentTarget)
		evt.currentTarget.className += " active";
*/
	if (cityName=="tbllaborclr" && document.getElementsByName("txt")[0])
		document.getElementsByName("txt")[0].focus();
	
  setCity({name:cityName});
}//end func

function navtowpvouchersOld(WPT_APP_ID){
	//test with LC ID 217708
	//const WPT_APP_ID=wptapp.WPT_APP_ID??0;
	
	if (WPT_APP_ID>0)
		navigate("/wpvouchers",{state:{WPT_APP_ID:WPT_APP_ID, IPM_LBR_CLR_APP_ID:wptapp.IPM_LBR_CLR_APP_ID ,BACK_PAGE:"lbr_clr_app"}});
	else
		fake_lbrclr_wptapp();
	
}//end func

async function fake_lbrclr_wptapp(e){

const params={
	LBR_CLR_APP_ID: wptapp.IPM_LBR_CLR_APP_ID
	, USERNAME: sessionStorage.getItem("USERNAME")
}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwpform/fake_lbrclr_wptapp',requestOptions)
      .then(res => res.json())
      .then(res => 	after_fake_lbrclr_wptapp(res, e) )
      .catch(err => console.log(err));

}//end func

async function after_fake_lbrclr_wptapp(res, e){
	
	const WPT_APP_ID=res.length?(res[0].WPT_APP_ID??0):0;
	if (WPT_APP_ID==0)
		showsnackbar("failed to create APS application.  try again or contact admin");
	else
		setCbbalrcp({checked:e.target.checked});
		//navtowpvouchers(WPT_APP_ID);
	
}//end func

async function updatelbrclrappdecision(){

const params={
	href: window.location.href
	, LBR_CLR_APP_ID: wptapp.IPM_LBR_CLR_APP_ID
	, DEC_ID: wptapp.DEC_ID
	, REVERSE_REASON: wptapp.REVERSE_REASON
	, APP_STATUS_ID: wptapp.APP_STATUS_ID
	, USERNAME: sessionStorage.getItem("USERNAME")
	, COMMENTS: wptapp.COMMENTS
}


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwptprocess/updatelbrclrappdecision',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatelbrclrappdecision(res) )
      .catch(err => console.log(err));

}//end func

function afterupdatelbrclrappdecision(res){
let UPDATE_COUNT=0;
if (res.length)
	if (res[0].UPDATE_COUNT)
		UPDATE_COUNT=res[0].UPDATE_COUNT;
	
	
if (UPDATE_COUNT>0){
	showsnackbar("application decision update done!");
	if (wptapp.DEC_ID==2){
		//approved
		//navtowpvouchers(wptapp.WPT_APP_ID);
		document.getElementById("cbbalrcp").checked=false;
		document.getElementById("cbbalrcp").click();
		if (document.getElementsByName("WPAMT[]")[0])
			document.getElementsByName("WPAMT[]")[0].focus();
		}//end if
	else {
		if (wptapp.DEC_ID==3 || wptapp.DEC_ID==4){
			letterforlbrclr(null, true);
			}
		//setTimeLeft(5);
		}//end else
	//reload the table to show the new decision
	tbllbrclrappdecision();
	}//end if
else
	showsnackbar("error: something went wrong");

//tbllbrclrappdecision();

setWptapp((prev)=>{
	return {...prev, NEW_DECISION:0}
	});

}//end func


async function getlbrclrLetter(e, decsnKey){

e.preventDefault();

const PDF_SIZE=1*(decsnKey.PDF_SIZE??0);
if (PDF_SIZE<=0){
	alert("seems the pdf file is not yet generated");
	return;
	}//end if

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( decsnKey )
  };	
  
if (!e.target.classList.contains("hidden"))
	e.target.classList.add("hidden");

  await fetch(resturl+'rarwptprocess/getlbrclrLetter',requestOptions)
      .then(res => 	aftergetlbrclrLetter(res, e, decsnKey.LBR_CLR_APP_ID) )
      .catch(err => console.log(err));
	  
}//end func

async function aftergetlbrclrLetter(res, e, decsnKey){

if (e.target.classList.contains("hidden"))
	e.target.classList.remove("hidden");

const blob = await res.blob();
//const blobBytesSize = blob.size;
console.log("blob.type: "+blob.type);

if (blob.type=="application/json"){
	let blob_text = await blob.text();
	console.log("blob_text: "+blob_text);
	const temp = JSON.parse(blob_text);
	const error=temp?(temp.error??""):"seems the file was not found on the server: "+decsnKey.FILE_PATH;
	alert(error);
	}
else
	saveAs(blob, "LabourClearanceLetter"+decsnKey.LBR_CLR_APP_ID+".pdf");



}//end func	

async function tbllbrclrappdecision(){

const params={
	LBR_CLR_APP_ID: wptapp.IPM_LBR_CLR_APP_ID??"0"
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwptprocess/tbllbrclrappdecision',requestOptions)
      .then(res => res.json())
      .then(res => 	aftertbllbrclrappdecision(res) )
      .catch(err => console.log(err));

}//end func

function aftertbllbrclrappdecision(res){

tbl_wptapp_endorsee();

if (!res.length)
	return;

let htmrows=[];
	
res.map((col, index) => {
	
	const key="tbldcns_"+index;
	let commentLink=col['DEC_COMMENTS_SHORT'];
	const decsnKey={
			LBR_CLR_APP_ID: col['LBR_CLR_APP_ID']
			, SEQ_NO: col['SEQ_NO']
			, PDF_SIZE: col['PDF_SIZE']
			, FILE_PATH: col['FILE_PATH']
			};
	if (col['DEC_ID']==3 || col['DEC_ID']==4)
		commentLink=<a href="#" className="nodecor" onClick={(e)=>{getlbrclrLetter(e, decsnKey);}} ><img src="img/pdf.gif" border="0" />&nbsp;{col['DEC_COMMENTS_SHORT']}</a>
	//const docNo=col['DOC_NO'];
	//const downloadLink=<a href="#" className="nodecor" id={"link_"+index} onClick={(e)=>{downloadDoc(e, docNo);}} ><img src='img/pdf.gif' border='0' />&nbsp;{docNo}</a>;
	
	const htmrow=<tr key={key} >
	
				<td align="center" >{col['TC_DEC_DATE']}</td>
				<td align="center" >{col['DECISION']}</td>
				<td align="center" title={col['DEC_COMMENTS']} >{commentLink}</td>
				<td align="center" >{col['CREATED_BY']}</td>
				<td align="center" >{col['REVERSED']}</td>
				<td align="left" >{col['REVERSE_REASON']}</td>
					{/*<td align="center" >{col['TC_UPDATED_DATE']}</td>*/}
				<td align="center" >{col['EMAIL_SENT']}</td>
				</tr>;
	htmrows.push(htmrow);
	
	});//end map	

setTbllbrclrdecision(htmrows);
}//end func



async function tbl_wptapp_endorsee(){

const params={WPT_APP_ID:wptapp.WPT_APP_ID, WORK_PERMIT_ID:wptapp.WORK_PERMIT_ID??0};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		


  await fetch(resturl+'rarwptprocess/tbl_wptapp_endorsee',requestOptions)
      .then(res => res.json())
      .then(res => 	after_tbl_wptapp_endorsee(res) )
      .catch(err => console.log(err));

}//end func

function after_tbl_wptapp_endorsee(res){
	
if (!res.length)
	return;

let htmrows=[];

	res.map((col, index) => {
		
		const key="tblendorc_"+index;
		const endorsee_id=col['endorsee_id'];
		//const openLink=<a href="#" className="nodecor" target="_blank" onClick={(e)=>{openWptprocess(e, WORK_PERMIT_ID);}} ><img src='img/folderyel.png' height='18' border='0' />&nbsp;{MPE_NAME}</a>;
	
		const htmrow=<tr key={key} >
					<td align="right" >{col['ENDORSEE_ID']}</td>
					<td align="left" >{col['NAME']}</td>
					<td align="left" >{col['GENDER']}</td>
					<td align="left" >{col['DOB']}</td>
					<td align="left" >{col['NATIONALITY']}</td>
					<td align="left" >{col['DECISION']}</td>
					</tr>;
		htmrows.push(htmrow);
		


		});//end map

setTblendorsee(htmrows);
}//end func

async function insertwptappendorsee(e){
e.preventDefault();

const userconf=window.confirm("update the table? This only works with apps from APS");
if (!userconf)
	return;

const params={
	 USERNAME: sessionStorage.getItem("USERNAME")??""
	, WPT_APP_ID: wptapp.WPT_APP_ID
	};


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwptprocess/insertwptappendorsee',requestOptions)
      .then(res => res.json())
      .then(res => 	afterinsertwptappendorsee(res) )
      .catch(err => console.log(err));

}//end func

function afterinsertwptappendorsee(res){
	tbl_wptapp_endorsee();
}//end func

	
async function getlbrclrorwptapp(LBR_CLR_APP_ID, WPT_APP_ID){

if (LBR_CLR_APP_ID+WPT_APP_ID==0)
	return;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {LBR_CLR_APP_ID:LBR_CLR_APP_ID, WPT_APP_ID:WPT_APP_ID} )
  };		

 await fetch(resturl+'rarwptprocess/getlbrclrorwptapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetlbrclrorwptapp(res) )
      .catch(err => console.log(err));

}//end func

function aftergetlbrclrorwptapp(res){

//console.log("aftergetlbrclrorwptapp res[0]:"+JSON.stringify(res[0]));

let datas=wptapp;
//datas['REF_NUM']=res[0].REF_NUM;

for(var attributename in res[0]){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
	}//end for	
	
setWptapp((prev)=>{
	return {...prev, datas}
});

openCity(null, "currlaborclr");
getwptvouchers(datas.DOC_NOS);
tbllbrclrappdecision();
window.scrollTo(0, 0);
}//end func

async function labr_clr_app_from_premOld(){

console.log("labr_clr_app_from_prem wptapp: "+JSON.stringify(wptapp));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( wptapp )
  };		

 await fetch(resturl+'rarwptprocess/labr_clr_app_from_prem',requestOptions)
      .then(res => res.json())
      .then(res => 	afterlabr_clr_app_from_prem(res) )
      .catch(err => console.log(err));

}//end func

function afterlabr_clr_app_from_prem(res){

console.log("afterlabr_clr_app_from_prem");
let datas=wptapp;

for(var attributename in res[0]){
	if ( attributename!="PHOTO_FILE" && attributename!="SIGNA_FILE" ){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
		
		}//end if
	}//end for	
	
	//setWptapp(datas);

datas.FROM_PREM=false;

setWptapp((prev)=>{
	return {...prev, datas}
});

//setWptapp(datas);
}//end func



async function getpastmonths(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

 await fetch(resturl+'rarxlreport/getpastmonths',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetpastmonths(res) )
      .catch(err => console.log(err));

}//end func



function aftergetpastmonths(res){

let tempopts=[];
res.map((col, index) => {
	const key="yrmm_"+index;
		tempopts.push(<option key={key} value={col['YRMM']}  >{col['MNTH']}</option>);
	});//end map

setPastmonths(tempopts);	
	
}//end func	
	
	
async function getcswkrlbrclrlistOld(){

const params={
	USERNAME:sessionStorage.getItem("USERNAME")
	, LBR_CLR_APP_ID: location.state?(location.state.IPM_LBR_CLR_APP_ID??""):""
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwptprocess/getcswkrlbrclrlist',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetcswkrlbrclrlist(res) )
      .catch(err => console.log(err));

}//end func

function aftergetcswkrlbrclrlist(res){


let temp=[];

res.map((col, index) => {
	const key="lbrclrlist_"+index;
	
	temp.push(<option key={key} value={col['VAL']}  >{col['OPT']}</option>);
	
	});//end map
setCswkrlbrclrlist(temp);
	
}//end func
	
async function getlcrstartoptions(){




   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

 await fetch(resturl+'rarwptprocess/getlcrstartoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetlcrstartoptions(res) )
      .catch(err => console.log(err));

}//end func



function aftergetlcrstartoptions(res){

let tempcountryoptions=[], tempagencyoptions=[], temppayperiodoptions=[], tempoccupationoptions=[];
let templcrtypeoptions=[], templocationoptions=[], tempstatusoptions=[], tempreviewtypeoptions=[], tempcategoryoptions=[];
let tempcombotype=[], tempcombodecisionopts=[], temparraycomment=[];
//<option value={wptapp.SALARY_SCALE}>{wptapp.SALARY_SCALE}</option>
res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const opt=col['OPT'];
	const val=col['VAL'];
	
	
	if (combo=='country')
		tempcountryoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='agency')
		tempagencyoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='payperiod')
		temppayperiodoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='occupation')
		tempoccupationoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='lcrtype')
		templcrtypeoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='location')
		templocationoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='status')
		tempstatusoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='reviewtype')
		tempreviewtypeoptions.push(<option key={key} value={val}  >{opt}</option>);
	
	else if (combo=='category')
		tempcategoryoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='lctype')//wptype
		tempcombotype.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='decision')//
		tempcombodecisionopts.push(<option key={key} value={val}  >{opt}</option>);	
	else if (combo=='comments')//
		temparraycomment.push(opt);	

	});//end map

setCountryoptions(tempcountryoptions);
setAgencyoptions(tempagencyoptions);
setPayperiodoptions(temppayperiodoptions);
setOccupationoptions(tempoccupationoptions);
setLcrtypeoptions(templcrtypeoptions);
setLocationoptions(templocationoptions);
setLaborclrstatus(tempstatusoptions);
setCombocategory(tempcategoryoptions);
//tempcombotype.push(<option key="board101" value="board"  >Board Applications</option>);
setCombotype(tempcombotype);
setReviewtypeoptions(tempreviewtypeoptions);

setDecisionoptions(tempcombodecisionopts);
setArraycomment(temparraycomment);

}//end func



async function deletelbrclrapp(e){

e.preventDefault();

const result=window.confirm("You can make changes if you revert to the pre-Clearance page. Proceed?");

if (!result)
	return;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME: sessionStorage.getItem("USERNAME"), IPM_LBR_CLR_APP_ID:wptapp.IPM_LBR_CLR_APP_ID} )
  };		

 await fetch(resturl+'rarwptprocess/deletelbrclrapp',requestOptions)
      .then(res => res.json())
      .then(res => 	afterdeletelbrclrapp(res) )
      .catch(err => console.log(err));

}//end func

function afterdeletelbrclrapp(res){
	if (res.length)
		if (res.length==1)
			navigate("/startlcrapp", {state:{WPT_APP_ID: res[0].WPT_APP_ID}});
}//end func







async function letterforwrkpmt(e) {
	if (e)
		e.preventDefault();
	
	if (wptapp.STATUS!="APPROVED"){
		window.alert("It must be approved");
		return;
		}
	
	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, PNAM: "WORK_PERMIT_ID"
		, PVAL: wptapp.WORK_PERMIT_ID
		, JASPER_FILE_NAME: "WorkPermitGeneralCover.jasper"
		, EXECUTEQUERY: ""
		, CALLABLESTATEMENT: " CALL BFADM.SP_RPT_WORK_PERMIT_COVER("+wptapp.WORK_PERMIT_ID+" , ~); "
		};
	//{  }
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

	if (e.target)
		e.target.style.visibility='hidden';


  await fetch(resturl+'rarwptprocess/preprunireportext',requestOptions)
      .then(res => 	afterletterforwrkpmt(res, e) )
      .catch(err => console.log(err));
	  
}//end func

async function afterletterforwrkpmt(res, e){
	const filename="WorkPermitGeneralCover"+wptapp.WORK_PERMIT_ID+".pdf";
	const blob = await res.blob();
	saveAs(blob, filename);
	if (e.target)
		e.target.style.visibility='visible';
	
}//end func







async function letterforlbrclr(e, skipSaveas) {
	if (e)
		e.preventDefault();
		/*
1	APPROVED
2	DENIED
3	DEFERRED
--test new letter with DELETED LC ID 209191
UPDATE LBR_CLR_APP SET DELETED=0 WHERE LBR_CLR_APP_ID=209191
*/
const statusId=wptapp.APP_STATUS_ID;
if (statusId>3){
	showsnackbar("The pdf file is available only for Status: Approved, Deferred, and Denied");
	return;
	}//end if

const IPM_LBR_CLR_APP_ID=wptapp.IPM_LBR_CLR_APP_ID??0;

let jasperFileName="";
const apppendFileName=wptapp.APP_STATUS_ID==1?"":"Letter";

if (wptapp.APP_STATUS_ID==1)
	jasperFileName="LaborCoverPage.jasper";
else if (wptapp.APP_STATUS_ID==2)
	jasperFileName="LaborClearDecline.jasper";
else if (wptapp.APP_STATUS_ID==3)
	jasperFileName="LaborClearDefer.jasper";

const fileIsletter=(wptapp.APP_STATUS_ID==1)?"":"Letter";
let resultFileName = jasperFileName.replace(".jasper", "")+fileIsletter+IPM_LBR_CLR_APP_ID+".pdf";
resultFileName=resultFileName.replace("LaborClear", "LabourClearance");
console.log("resultFileName: "+resultFileName);

if (IPM_LBR_CLR_APP_ID<1){
	alert("Cannot generate Cover page without a Labour Clearance Id #");
	return;
	}

	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, PNAM: "LBR_CLR_APP_ID"
		, PVAL: IPM_LBR_CLR_APP_ID
		, JASPER_FILE_NAME: jasperFileName
		, EXECUTEQUERY: ""
		, CALLABLESTATEMENT: " CALL BFADM.SP_RPT_LABOR_CLEAR_LETTER("+IPM_LBR_CLR_APP_ID+" , ~); "
		};

	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

	if (e)
		if (e.target)
			e.target.style.visibility='hidden';
	
//C:\scripts\ireportfromdb\rptlcrdefer

  await fetch(resturl+'rarwptprocess/preprunireportext',requestOptions)
      .then(res => 	afterletterforlbrclr(res, e, resultFileName, skipSaveas) )
      .catch(err => console.log(err));
	  
}//end func

async function afterletterforlbrclr(res, e, fileName, skipSaveas){
	//const filename="LaborClearDecline"+wptapp.IPM_LBR_CLR_APP_ID+".pdf"; 206850
	console.log("skipSaveas: "+skipSaveas);
	if (skipSaveas==false || wptapp.WEB_USER_EMAIL==""){
		const blob = await res.blob();
		saveAs(blob, fileName);
		}//end if
		
	
		
	if (e)
		if (e.target)
			e.target.style.visibility='visible';
	
}//end func


async function makevchrpdffile(e, i){
	e.preventDefault();
	
/*  
J5020
2624379594
	console.log("makevchrpdffile i: "+i);
	console.log("makevchrpdffile arrsearchdocs.length: "+arrsearchdocs.length);
	console.log("makevchrpdffile arrsearchdocs[n-1]: "+arrsearchdocs[arrsearchdocs.length-1]);
	console.log("makevchrpdffile arrsearchdocs[i]: "+JSON.stringify(arrsearchdocs[i]));
*/

	const conf=window.confirm("You may have to wait some time before the pdf is ready to download.  proceed?");
	
	if (!conf)
		return;

	e.target.style.visibility='hidden';
	
	const params={
		DOC_NO: arrsearchdocs[i].DOC_NO
		, DOC_STATE: arrsearchdocs[i].DOC_STATE
		, PAID_AMT: arrsearchdocs[i].AMOUNT??""
		, PAID_DATE: arrsearchdocs[i].DATE_PAID??""
		};
	
	console.log("makevchrpdffile: "+JSON.stringify(params));
	const filename=arrsearchdocs[i].DOC_NO+".pdf";
	//const filename="RCP.pdf";

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,responseType: "blob"
	  ,body: JSON.stringify( params )
  };		

//setTblvchrs([]);

	//await fetch('https://customsprem.gov.tc/rarvchrpdffile/makevchrpdffile',requestOptions)
	await fetch(customspremurl+'rarvchrpdffile/makevchrpdffile',requestOptions)
	  .then(data => aftermakevchrpdffile(data, e, filename) )
      .catch(err => console.log(err));	


/*

// Use cors middleware
app.use(cors({
    origin: '*', // Wildcard is NOT for Production
    methods: 'GET,HEAD,PUT,PATCH,POST,DELETE',
    credentials: true,
}));
*/
	
}//end func

async function aftermakevchrpdffile(res, e, filename){
	e.target.style.visibility='visible';
	
	const blob = await res.blob();
	saveAs(blob, filename);
	
}//end func


async function downloadDoc(e, docNo, PAID_AMT, PAID_DATE){
	e.preventDefault();
	cssclass(e.target.id, "hidden", 1);
	//e.target.style.visibility='hidden';
	const filename=docNo+".pdf";
	let params={filename: filename};
	let urlpath="rarwptapp/getvchrpdffile";
	const cbprintpaidrcp=document.getElementById("cbprintpaidrcp");
	if (cbprintpaidrcp.checked==true){
		/*
		to print paid receipt we call makevchrpdffile instead of getvchrpdffile
		*/
		urlpath="rarvchrpdffile/makevchrpdffile";
		//format for PAID_DATE is 29-JUL-2026
		params={
		DOC_NO: docNo
		, PAID_AMT: PAID_AMT
		, PAID_DATE: PAID_DATE
		};
		}//end if
	//const filename="RCP.pdf";

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,responseType: "blob"
	  ,body: JSON.stringify( params )
  };		
//setTblvchrs([]);
setDowait({show:true});
 await fetch(customspremurl+urlpath,requestOptions)
     
      .then(data => 	afterdownloadDoc(null, data, e, filename) )
      .catch(err => afterdownloadDoc(err, null, e, filename));
	
	
}//end func

async function afterdownloadDoc(err, res, e, filename){
	cssclass(e.target.id, "hidden", 0);
	setDowait({show:false});
	
	if (err){
		console.log(err);
		window.alert(err);
		return;
		}
	//e.target.style.visibility='visible';
	
	const blob = await res.blob();
	saveAs(blob, filename);
	

}//end func




async function getworkpermitforperson(PERSON_ID){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {PERSON_ID:PERSON_ID} )
  };		

setTblworkpermits([]);

 await fetch(resturl+'rarwptprocess/getworkpermitforperson',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetworkpermitforperson(res) )
      .catch(err => console.log(err));

}//end func


function aftergetworkpermitforperson(res){
	
if (!res.length){
	return;
	}

let temp=[];

	res.map((col, index) => {
		const WORK_PERMIT_ID=col['WORK_PERMIT_ID'];
		//const downloadLink=<a href="#" className="nodecor" id={"link_"+index} onClick={(e)=>{downloadDoc(e, docNo);}} ><img src='img/pdf.gif' border='0' />&nbsp;{docNo}</a>;
		const key="doctr_"+index;
		const radioId="rd_wptid_"+WORK_PERMIT_ID;
		temp.push(
			<tr key={key} >
			<td align="right" >{index+1}</td>
			<td align="left" ><input type="radio" name="rd_rdwpt" id={radioId} onClick={(e)=>{workpermitChange(WORK_PERMIT_ID);}} /><label htmlFor={radioId} className="hand" >{WORK_PERMIT_ID}</label></td>
			<td align="left" >{col['CREATED_DATE']}</td>
			<td align="left" >{col['WORK_PERMIT_NO']}</td>
			<td align="left" >{col['FULL_NAME']}</td>
			<td align="left" >{col['APP_TYPE']}</td>
			<td align="left" >{col['STATUS']}</td>
			<td align="left" >{col['DATE_ISSUE']}</td>
			<td align="left" >{col['EXPIRE_DATE']}</td>
			<td align="left" >{col['OCCUPATION']}</td>
			<td align="left" >{col['EMPLOYER']}</td>
			<td align="left" >{col['CARD_PRINT_DATE']}</td>
			</tr>
			);
		});//end map

setTblworkpermits(temp);
/*
		<th>Work<br/>Pmt. Id</th>
		<th>create<br/>date</th>
		<th>Immigr.<br/>Ref. #</th>
		<th>Employee</th>
		<th>Type</th>
		<th>Status</th>
		<th>Issue<br/>date</th>
		<th>Expire<br/>date</th>
		<th>Occupation</th>
		<th>Employer</th>
*/
}//end func


async function workpermitChange(Id){
setWorkpermit((prev)=>{
	return {...prev, id:Id}
	});

setWptapp((prev)=>{
	return {...prev, WORK_PERMIT_ID:Id}
	});

}//end func




async function getwrkpmtdetail(WORK_PERMIT_ID){
	
		   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), WORK_PERMIT_ID:WORK_PERMIT_ID} )
  };	
  
  setDowait({show:true});
  
  await  fetch(resturl+'rarwpform/getwrkpmtdetail',requestOptions)
      .then(res => res.json())
      .then(res => aftergetwrkpmtdetail(res)	 )
      .catch(err => console.log(err));	
}//end func

async function aftergetwrkpmtdetail(res){

setDowait({show:false});

//const updated_date=res.length?(res[0].updated_date??""):"";
if (!res[0].aps.length){
	window.alert("failed");
	return;
	}
	

	//const arrFld=" work_permit_no, employer, last_name, first_name, status, date_issue, expire_date, updated_by, updated_date, approved_by, approved_date, card_no, ActivityDateTime, collectDate, collectPerson".split(",");
	
	const arrFld=" first_name, status, date_issue, expire_date, updated_by, updated_date, approved_by, approved_date, card_no, ActivityDateTime, collectDate, collectPerson".split(",");
	
	let apshtmcells=[], ipmhtmcells=[];
	const apsres = res[0].aps[0];
	const ipmres = res[0].ipm[0];
	for (var i=0; i<arrFld.length; i++){
		const fld=arrFld[i].trim();

		apshtmcells.push(<td align="left" >{apsres[fld.toUpperCase()]??""}</td>);
		ipmhtmcells.push(<td align="left" >{ipmres[fld]??""}</td>);

		}//end for
	
	console.log("apshtmcells: "+JSON.stringify(apshtmcells));
	
	setTblwrkpmt({aps:apshtmcells, ipm:ipmhtmcells});

}//end func



function clickworkpermit(e){
	e.preventDefault();
	if (1*workpermit.id==0){
		const confirmed=window.confirm("a work permit application will be created in IPM and APS. Ok?");
		if (!confirmed)
			return;
		getworkpermitforexport();
		}//end if
	else{
		console.log("workpermit.id: "+workpermit.id);
		//navigate("/wptform", {state:{WORK_PERMIT_ID:workpermit.id}});
		navigate("/wptprocess", {state:{WORK_PERMIT_ID:workpermit.id}});
		//navigate("/wptprocess", {state:{WORK_PERMIT_ID:workpermit.id}} );
		}
		
}//end func

async function getxlfilename(e, flag){
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };	
  
  await  fetch(resturl+'rarxlreport/getxlfilename',requestOptions)
      .then(res => res.json())
      .then(res => 	{
		  if (flag=="rptlbrclrmonth")
			  callrptlbrclrmonth(res, e);
	  }  )
      .catch(err => console.log(err));	
}//end func

async function callrptlbrclrmonth(res, e){

let FILE_NAME="default_file_name";
if (res.length)
	FILE_NAME="Lbr_Clearance_Monthly_"+res[0].FILE_NAME;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {YRMM:e.target.value} )
  };		

if (!e.target.classList.contains("hidden"))
	e.target.classList.add("hidden");

 await fetch(resturl+'rarxlreport/rptlbrclrmonth',requestOptions)
      .then(res => 	aftercallrptlbrclrmonth(res, e, FILE_NAME) )
      .catch(err => console.log(err));

}//end func


async function aftercallrptlbrclrmonth(res, e, FILE_NAME){
	
if (e.target.classList.contains("hidden"))
	e.target.classList.remove("hidden");
	
	const blob = await res.blob();
	saveAs(blob, FILE_NAME+".xlsx");
	
}//end func

async function getwptvouchers(docNos){

console.log("getwptvouchers docNos: "+JSON.stringify(docNos));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VCHR_TYPE:"LC", WPT_APP_ID:wptapp.WPT_APP_ID?wptapp.WPT_APP_ID:0, USERNAME:sessionStorage.getItem("USERNAME")} )
  };		

 await fetch(resturl+'rarwpform/getwptvouchers',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptvouchers(res, docNos) )
      .catch(err => console.log(err));

}//end func


function aftergetwptvouchers(res, docNos){
	
let numdoc=0;	

const vchrs=res[0].vchrs;

if (vchrs.length)
	if (vchrs.length>0)
		numdoc=vchrs.length;

let temp=[];
if (numdoc==0){
	let arrtemp=[];
	if (docNos.length>8)
		arrtemp=docNos.split(",");
	
	for (var i=0; i<2; i++){
		const key="doctr_"+i;
		const ix=i;
		temp.push(
			<tr key={key} >
			<td align="center" ><input size="3" name="arrdocno[]" defaultValue={arrtemp[i]} onChange={(e)=>{docnoChange(ix, e)}}  onFocus={(e)=>{e.target.select();}} style={{textAlign:"center"}} /></td>
			<td align="left" colSpan="3" >&nbsp;&nbsp;&lt;&lt;-- type the last 4 digits from paid receipt #</td>
			</tr>
			);
		}//end for
	}//end if
else{
	vchrs.map((col, index) => {
		const docNo=col['DOC_NO'];
		const AMOUNT=col['AMOUNT'];
		const PAID_DATE=col['PAID_DATE'];
		
		const downloadLink=<a href="#" className="nodecor" id={"link_"+index} onClick={(e)=>{downloadDoc(e, docNo, AMOUNT, PAID_DATE);}} ><img src='img/pdf.gif' border='0' />&nbsp;{docNo}</a>;
		const key="doctr_"+index;
		temp.push(
			<tr key={key} >
			<td align="center" >{downloadLink}</td>
			<td align="right" >
				<a href="#" onClick={(e)=>{getvchrstate(e, docNo);}} title={col['ACCT_DESCP_1']} className="nodecor" ><img src="img/noicon.png" border="0" /></a>
				&nbsp;
				{col['AMOUNT']}
			</td>
			<td align="center" >{col['STR_CREATE_DATE']}</td>
			<td align="center" >{col['CHR_DATE_PAID']}</td>
			</tr>
			);
		});//end map
	}//end else

setTblvoucher(temp);
}//end func




async function getvchrstate(e, docNo){
	//getvchrstate
	e.preventDefault();
e.target.style.visibility='hidden';

const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( {DOC_NO:docNo})
};		

await fetch(customspremurl+'rarwptapp/getvchrstate',requestOptions)
  .then(res => res.json())
  .then(res => 	aftergetvchrstate(res, e.target, docNo) )
  .catch(err => console.log(err));	
	
}//end func

function aftergetvchrstate(res, elem, docNo){
	elem.style.visibility='visible';
var DOC_STATE_DESC=null;
if (res.length)
	if (res.length==1)
		DOC_STATE_DESC=res[0].DOC_STATE_DESC;
	
if (DOC_STATE_DESC=='DISCARDED')
	cancelwpdoc(docNo);
else
	window.alert('First change document status from '+DOC_STATE_DESC+' to DISCARDED in SIGTAS');
	
}//end func

async function cancelwpdoc(docNo){


const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( {DOC_NO:docNo, USERNAME:sessionStorage.getItem("USERNAME")})
};		

await fetch(resturl+'rarwpform/cancelwpdoc',requestOptions)
  .then(res => res.json())
  .then(res => 	aftercancelwpdoc(res) )
  .catch(err => console.log(err));	
	
}//end func

function aftercancelwpdoc(res){
	let cancel_count=0;
	if (res.length)
		if (res.length==1)
			cancel_count=res[0].CANCEL_COUNT;
		
	if (cancel_count==0)
		showsnackbar("that failed.  please try again or contact admin");
	else{
		showsnackbar("cancellation complete on APS Portal only.<br/>SIGTAS is not automatically updated");
		getwptvouchers();
		}
		
}//end func

function docnoChange(ix, e){
//show btnsavedocno only when complete
//showBtnsave();
const userdocno=e.target.value.trim();
const docno=userdocno.length<5?userdocno:arrdocno[ix];

let temp=arrdocno;
temp[ix]=docno;
//console.log("docnoChange temp: "+JSON.stringify(temp));
setArrdocno((prev)=>{
	return [...temp];
	});

for (var i=0; i<temp.length; i++)
	if (document.getElementsByName("arrdocno[]")[i]){
		const elem=document.getElementsByName("arrdocno[]")[i];
		console.log("over write elem "+i+": "+elem.value);
		elem.value=temp[i];
		//elem.value="ssss";
		}//end if

document.getElementById("btnsavedocno").style.visibility=(temp[0].length==4&&temp[1].length==4)?"visible":"hidden";

/*

setArrdocno((prev)=>{
	prev=temp;
	return [...prev]
	});
	
note I wanted to bind the inputs using value={arrdocno[i]}
but that failed so I just update the input values in the useEffect of arrdocno
	setArrdocno((prev)=>{
		prev[0]=temp[0];
		prev[1]=temp[1];
		return [...prev, temp]
		});

*/
	
}//end func

async function savedocno(e){
	e.preventDefault();
	e.target.style.visibility="hidden";
	//e.target.classList.add("hidden");
	const LBR_CLR_APP_ID=wptapp.IPM_LBR_CLR_APP_ID?wptapp.IPM_LBR_CLR_APP_ID:0;
	const WPT_APP_ID=wptapp.WPT_APP_ID?wptapp.WPT_APP_ID:0;
	
	const elem=document.getElementsByName("arrdocno[]");
	let temp=[];
	for (var i=0; i<elem.length; i++)
		temp.push(elem[i].value);
	
	console.log("savedocno: "+JSON.stringify(temp));
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {arrdocno:temp, WPT_APP_ID:WPT_APP_ID, LBR_CLR_APP_ID:LBR_CLR_APP_ID} )
  };		

 await fetch(resturl+'rarwptprocess/savelbrclrdocno',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersavelbrclrdocno(res) )
      .catch(err => console.log(err));	
	
}//end func

function aftersavelbrclrdocno(res){
showsnackbar("done!");
}//end func

async function gettbllaborclr(){
const EMAIL=sessionStorage.getItem("EMAIL");
console.log('EMAIL: '+EMAIL);
const USERNAME=sessionStorage.getItem("USERNAME")==undefined?sessionStorage.getItem("EMAIL"):sessionStorage.getItem("USERNAME");


const params={
	USERNAME:USERNAME
, crit:searchcrit
, DATES: searchcrit.dates
}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDowaittbl({show:true});
setTbllaborclr([]);

  await fetch(resturl+'rarwptprocess/gettbllaborclr',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettbllaborclr(res) )
      .catch(err => console.log(err));

}//end func

function openlaborclr(e, WPT_APP_ID, LBR_CLR_APP_ID){
	
	console.log("openlaborclr LBR_CLR_APP_ID: "+LBR_CLR_APP_ID);
	
	e.preventDefault();
	setWptapp((prev)=>{
		return {
			...prev
			, WPT_APP_ID:WPT_APP_ID
			, IPM_LBR_CLR_APP_ID:LBR_CLR_APP_ID
			}
	});
	
}//end func

function aftergettbllaborclr(res){
	
	console.log("aftergettbllaborclr res.length: "+res.length);
	
	setDowaittbl({show:false});
	
if (!res.length)
	return;

let htmrows=[];

	res.map((col, index) => {
		
		const key="tblwptproc_"+index;
		const WPT_APP_ID=col['WPT_APP_ID'];
		const LBR_CLR_APP_ID=col['LBR_CLR_APP_ID'];
		const MPE_NAME=col['MPE_NAME'];
		const openLink=<a href="#" className="nodecor" target="_blank" onClick={(e)=>{openlaborclr(e, WPT_APP_ID, LBR_CLR_APP_ID);}} ><img src='img/folderyel.png' height='18' border='0' />&nbsp;{MPE_NAME}</a>;
	
		const htmrow=<tr key={key} >
					<td align="right" >{index+1}</td>
					<td align="right" >{LBR_CLR_APP_ID}</td>
					<td align="center" >{col['LCODE']}</td>
					<td align="left" >{col['UPDATED_DATE']}</td>
					<td align="left" >{col['UPDATED_BY']}</td>
					<td align="left" >{col['REF_NUM']}</td>
					<td align="left" >{col['IMG_REF_NO']}</td>
					<td align="left" >{openLink}</td>
					<td align="left" >{col['APP_TYPE']}</td>
					<td align="left" >{col['STATUS']}</td>
					<td align="left" >{col['OCCUPATION']}</td>
					<td align="left" >{col['REVIEW_TYPE']}</td>
					<td align="left" >{col['ENDORSEMENT']}</td>
					<td align="left" >{col['MPR_NAME']}</td>
					</tr>;
		htmrows.push(htmrow);
		
		});//end map

setTbllaborclr(htmrows);
	
}//end func









async function createBlobFromFile(file){
	
    //const file = await fs.readFile(path, function (err, data) { 	});
	 return new Blob([file]);
   
}//end func

async function sendapptoprintOld(photoFile, signaFile){
	
	
	const photoBlob=await createBlobFromFile(photoFile);
	const signaBlob=await createBlobFromFile(signaFile);

	const formData = new FormData();

	formData.append('IPM_LBR_CLR_APP_ID', wptapp.IPM_LBR_CLR_APP_ID);
	formData.append('file1', photoBlob, 'photo.png');
	formData.append('file2', signaBlob, 'signa.png');

	
	//import fetch from 'node-fetch';
const requestOptions = {		
	method: 'POST',
		body: formData
};

console.log("will fetch to sendapptoprint");

  await fetch(customspremurl+'rarmssql/sendapptoprint',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersendapptoprint(res) )
      .catch(err => console.log(err));
	
}//end func

function aftersendapptoprint(res){
	
}//end func

function handleFocus(e){
	e.target.select();
}


function clearandgreycomments(){
const len = document.getElementsByName("VCHR_COMMENT[]").length;
for (var i=0; i<len; i++){
	document.getElementsByName("VCHR_COMMENT[]")[i].value='';
	//document.getElementsByName("VCHR_COMMENT[]")[i].readOnly=true;
	//document.getElementsByName("VCHR_COMMENT[]")[i].
	}
	
}//end for




async function updatereviewtype(e){
	
	e.preventDefault();
	
	const params={
		USERNAME: sessionStorage.getItem("USERNAME")
		, WPT_APP_ID: wptapp.WPT_APP_ID
		, IPM_LBR_CLR_APP_ID: wptapp.IPM_LBR_CLR_APP_ID
		, APP_TYPE_ID: wptapp.APP_TYPE_ID
		, REVIEW_TYPE: wptapp.REVIEW_TYPE
		, ONLY_UPDATE_REVIEW_TYPE: 1
	}
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

cssclass("btnreviewtype", "hidden", 1);

await fetch(resturl+'rarwpform/updatereviewtype',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatereviewtype(res) )
      .catch(err => console.log(err));

}//end func

function afterupdatereviewtype(res){
	const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;
	if (UPDATE_COUNT==0)
		window.alert("update failed!");
	else{
		showsnackbar("done!");
		setWptapp((prev)=>{
			return {
				...prev
				, REQ_BOARD_APPROVAL: res[0].REQ_BOARD_APPROVAL
				, REVIEW_TYPE: res[0].REVIEW_TYPE
				};
			});
		}//end else
		
}//end func








function boardChange(e){
	
	const {name, value}=e.target;
	setWptapp((prev)=>{
		return {...prev, [name]:value}
		});	
		
	cssclass("btnreviewtype", "hidden", 0);
	
		
}//end func

function handleChange(e){
	
	const {name, value}=e.target;
//console.log("handleChange name: "+name+" -> "+value);	
//document.getElementById('btnsave').style.visibility='visible';
if (name=="APP_STATUS_ID"){
	showsnackbar("change the Decision instead");
	return
	}//end if
	
if (name=="WRK_PMT_NUM_YRS"){
	let WRK_PMT_STARTS="", WRK_PMT_ENDS="";
	if (wptapp.WRK_PMT_STARTS){
		WRK_PMT_STARTS = new Date(wptapp.WRK_PMT_STARTS);
		console.log("add "+(value*12)+" months to WRK_PMT_STARTS: "+WRK_PMT_STARTS);
		var DT_WRK_PMT_ENDS = new Date(new Date(WRK_PMT_STARTS).setMonth(WRK_PMT_STARTS.getMonth() + (value*12)));	
		DT_WRK_PMT_ENDS.setDate(DT_WRK_PMT_ENDS.getDate() + 1);
			
		var day = ("0" + DT_WRK_PMT_ENDS.getDate()).slice(-2);
		var month = ("0" + (DT_WRK_PMT_ENDS.getMonth() + 1)).slice(-2);
		WRK_PMT_ENDS = DT_WRK_PMT_ENDS.getFullYear()+"-"+(month)+"-"+(day) ;
		}//end if
		
	console.log("WRK_PMT_ENDS: "+WRK_PMT_ENDS);
	setWptapp((prev)=>{
		return {...prev, WRK_PMT_ENDS:WRK_PMT_ENDS}
		});	
	showbtnsavevchrchanges();
	//clearandgreycomments();
	}//end if

if (name=="WRK_PMT_STARTS" || name=="WRK_PMT_ENDS"){
	showbtnsavevchrchanges();
	//clearandgreycomments();
	}
	
	
if (name=="DEC_ID"){
	
	let reverse_reason="";
	
	if (wptapp.DEC_ID!=""){
		//if there is already a decision made
		if (value=="")
			return;
		
		reverse_reason=window.prompt("reverse the current decision? enter the reason: ");
		if (!reverse_reason)
			return;
		if (reverse_reason.trim=="")
			return;
		
		}//end if
	
	console.log("wptapp.COMMENTS "+wptapp.COMMENTS);
	if (wptapp.COMMENTS.trim()==""){
		console.log("wptapp.COMMENTS.trim=='' and value="+value);
		if (value==3||value==4){
			window.alert("Please enter the reason in the comments box first");
			return;
			}
		}
	
	for (var i=0; i<arrdecidtostatusid.length; i++)
		if (arrdecidtostatusid[i].dec_id==value){
			setWptapp((prev)=>{
				return {...prev, [name]:value, APP_STATUS_ID:arrdecidtostatusid[i].status_id, REVERSE_REASON:reverse_reason, NEW_DECISION:1}
				});
			return;
			}//end if
	}//end if
	
showBtnsave();
setWptapp((prev)=>{
	return {...prev, [name]:value}
	});

if (name=="MED_REC" && value==0){
	setWptapp((prev)=>{
		return {
			...prev
			, MED_CERT_ISSUE_DATE:''
			, MED_CERT_EXPIRE_DATE:''
			}
		});
	
	}//end if


}//end func

function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");

	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func





		
function showCheckboxes(flag) {
	let checkboxes = document.getElementById("checkBoxes");

if (flag!=null)
	show=flag;

	if (show) {
		
/*
		if (document.getElementById('comboticksresult').value.trim()!=""){
			alert('This only works when the comment is empty.\r\nremove the comment if you want to proceed.');
			return;
			}//end if

*/		
		
		
		checkboxes.style.display = "block";
		show = false;
	} else {
		checkboxes.style.display = "none";
		show = true;
		var i=0, len=document.getElementsByName("cbopts").length;
		for (var i=0; i<len; i++){
			document.getElementsByName("cbopts")[i].checked=false;
			}
		}//end else

	if (document.getElementById("btnclosecb"))
		document.getElementById("btnclosecb").style.visibility=(show==true)?'hidden':'visible';

	
	if (listener==false){

		window.addEventListener("click", windowOnClick);
		listener=true;


		}//end if

			
}//end func
		

function setupCheckboxes(){
//EMPLOYER HAS NOT SHOWN A GENUINE NEED FOR THIS WORKER	
//const arrItem="Applicant is Stop listed., Appeal submitted after the 14 days period., Approved by Deputy Commissioner of Labour., The employer should make every effort to fill this position locally., Medical is not authentic., Minister overturn letter attached., Needs a Newspaper Ad., Needs a Medical Certificate., Needs a Passport page copy., Needs a Police Record., Needs a Work contract., No hit from Intel Vetting., Passport has expired., Please pay attention to the contract.,Please provide assurances that full time employment is available for this worker., Switched employer.,The employer has not shown a genuine need for this worker.".split(",");
//console.log("setupCheckboxes: "+JSON.stringify(arraycomment));
const arrItem=arraycomment;

let temparrcheckbox=[];

for (var i=0; i<arrItem.length; i++){
	const item=arrItem[i].trim();
	const checkboxId="checkboxId_"+i;
	const key="checkboxId_"+i+"_label";
	
	temparrcheckbox.push(
			<label htmlFor={checkboxId} key={key} >
			<input type="checkbox" id={checkboxId} name="cbopts" defaultValue={item} onClick={ (e)=>{ writeCheckboxValue(e.target.checked, item); } } />
			{item}
			</label>	
	);
	}//end for
	
setArrcheckbox(temparrcheckbox);

document.getElementById("checkBoxes").style.display = "none";

}//end func


function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
	
console.log('event.target === modalsm: '+(event.target === modalsm));
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }//end if
	
	
//console.log("inside EventListener show: "+show);
//console.log("inside EventListener e.target.id: "+event.target.id);

if (show==false && event.target===document.getElementById("checkBoxes")) {
	document.getElementById("checkBoxes").style.display = "none";
	show = true;
	}	//end if
	
}//end func

async function submitform1(e) {
	e.preventDefault();
	showCheckboxes(false);
	let temp={LBR_CLR_APP_ID: wptapp.IPM_LBR_CLR_APP_ID};
	const lsFld="EMPL_ID, APP_STATUS_ID, IMG_REF_NO, APP_TYPE_ID, LOCATION_ID, AGENCY_ID, SALARY_WAGES, WAGE_DENOM, APP_DATE, REQ_BOARD_APPROVAL, DEC_ID " +
				"PERSON_ID, MED_REC, MED_CERT_ISSUE_DATE, MED_CERT_EXPIRE_DATE, OCCUPATION_ID, CON_START_DATE, CON_END_DATE, DATE_ISSUED, EXP_DATE, COMMENTS, BOARD_REMARKS"
	//const arrFld="IMG_REF_NO, MED_CERT_ISSUE_DATE, MED_CERT_EXPIRE_DATE, APP_STATUS_ID, MED_REC, FIRST_NAME, LAST_NAME, PASSPORT, APP_TYPE_ID, LOCATION_ID, CON_START_DATE, CON_END_DATE, DATE_ISSUED, EXP_DATE, COMMENTS, AGENCY_ID, OCCUPATION_ID".split(",");
	const arrFld=lsFld.split(",");
	for (var i=0; i<arrFld.length; i++){
		const fldNam=(""+arrFld[i]).trim();
		temp[fldNam]=wptapp[fldNam];
		}//end for
		
	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, WPT_APP_ID: wptapp.WPT_APP_ID?wptapp.WPT_APP_ID:0
		, LBR_CLR_APP_ID: wptapp.IPM_LBR_CLR_APP_ID
		, formdata: temp
		};
	
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(resturl+'rarwptprocess/updatelbrclrapp',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatelbrclrapp(res) )
      .catch(err => console.log(err));
	  
}//end func

async function getworkpermitforexport() {
	

	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, IPM_LBR_CLR_APP_ID: wptapp.IPM_LBR_CLR_APP_ID
		};
	
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(resturl+'rarwptprocess/getworkpermitforexport',requestOptions)
      .then(res => res.json())
      .then(res => 	impworkpermit(res) )
      .catch(err => console.log(err));
	  
}//end func


async function impworkpermit(res) {
	//console.log("impworkpermit res: "+JSON.stringify(res));
//	const arrsrc="IMG_REF_NO, last_name, first_name, full_name, employer, dob, gender, passport_no, country, occupation, occ_cat_id, category, nationality, location, card_no, spouse, child, fees, penalty_fee, concern, status, date_issue, expire_date, created_by, created_date, updated_by, updated_date, app_type, photo_file_name, thumb_file_name, date_received, decision, board_remarks".split(",");
//	const arrdes="work_permit_no, last_name, first_name, full_name, employer, dob, gender, passport_no, country, occupation, occ_cat_id, category, nationality, location, card_no, spouse, child, fees, penalty_fee, concern, status, date_issue, expire_date, created_by, created_date, updated_by, updated_date, app_type, photo_file_name, thumb_file_name, date_received, decision, board_remarks".split(",");
let work_permit_no=null;

	if (res.length)
		if (res.length==1)
			work_permit_no=res[0].WORK_PERMIT_NO
			
if (work_permit_no==null){
	alert("failed to get work permit data for export to IPM System");
	return;
	}
	
	let params=res[0];
	params.USERNAME= sessionStorage.getItem("USERNAME");
	
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

//let customspremurl2="https://customsprem.gov.tc/";
  await fetch(customspremurl+'rarmssql/impworkpermit',requestOptions)
      .then(res => res.json())
      .then(res => 	uploadworkpermit(res) )
      .catch(err => console.log(err));
	  
}//end func


async function 	uploadworkpermit(res){
	
	console.log("uploadworkpermit: "+JSON.stringify(res));
	
	let NEW_WORK_PERMIT_ID=0;
if (res.length)	
	if (res.length==1)	
		NEW_WORK_PERMIT_ID=res[0].work_permit_id;

if (NEW_WORK_PERMIT_ID==0){
	window.alert("failed to get a new work_permit_id");
	return;
	}
	
	let params=res[0];
	params.USERNAME= sessionStorage.getItem("USERNAME");
	params.IPM_LBR_CLR_APP_ID= wptapp.IPM_LBR_CLR_APP_ID;
	
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {formdata: params} )
  };		

  await fetch(resturl+'rarwptprocess/uploadworkpermit',requestOptions)
      .then(res => res.json())
      .then(res => 	afteruploadworkpermit(res) )
      .catch(err => console.log(err));
	  
}//end func

function afteruploadworkpermit(res){
let NEW_WORK_PERMIT_ID=0;
if (res.length)	
	if (res.length==1)	
		NEW_WORK_PERMIT_ID=res[0].work_permit_id;

if (NEW_WORK_PERMIT_ID>0)
	navigate("/wptprocess", {state:{WORK_PERMIT_ID:NEW_WORK_PERMIT_ID}});
else
	showsnackbar("something went wrong.  please try again or contact admin");

}//end func


function nextsearchresapp(e, nextapp){
	e.preventDefault();
//const WPT_APP_ID=e.target.selectedIndex; length 5
cssclass("btnprevsearchapp", "hidden", 0);
cssclass("btnnextsearchapp", "hidden", 0);

const tempcombo=document.getElementById("combosearchresapps");

if (nextapp==1){
	if (tempcombo.selectedIndex<tempcombo.options.length-1)
		tempcombo.selectedIndex+=1;
	else{
		showsnackbar("no more applications");
		cssclass("btnnextsearchapp", "hidden", 1);
		}//end else
		
	}//end if 

if (nextapp==0){
	if (tempcombo.selectedIndex>0)
		tempcombo.selectedIndex-=1;
	else{
		showsnackbar("no more applications");
		cssclass("btnprevsearchapp", "hidden", 1);
		}//end else
		
	}//end if 
	
searchresappsChange({target:{value:tempcombo.value}});		
}//end func

function searchresappsChange(e){
	
	const WPT_APP_ID = e.target.value;
	let IPM_LBR_CLR_APP_ID=0;
	const searchresapps=location.state.searchresapps;
	
	for (var i=0; i<searchresapps.length; i++){
		if (searchresapps[i].WPT_APP_ID==WPT_APP_ID)
			IPM_LBR_CLR_APP_ID=searchresapps[i].IPM_LBR_CLR_APP_ID
		}//end for
	
	setWptapp((prev)=>{
		return {...prev, WPT_APP_ID:WPT_APP_ID, IPM_LBR_CLR_APP_ID:IPM_LBR_CLR_APP_ID, REF_NUM:null}
		});
}//end func



async function searchworkervchrs(e){

if (e)
	cssclass(e.target.id, "hidden", 1);
	
	const date1=docsearchcrit.date==""?"":docsearchcrit.date;
	
	let params={
		doc_no: ""// later will b able to filter by doc num
		, app_date: date1==""?wptapp.APP_DATE:date1
		, modify_date: date1==""?wptapp.CLI_MODIFY_DATE:date1
		, img_ref: wptapp.IMG_REF_NO
		, mpe_fname: wptapp.FIRST_NAME
		, mpe_lname: wptapp.LAST_NAME
		, mprname: wptapp.MPR_NAME
	};
	
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setArrsearchdocs([]);

  await fetch(resturl+'rarwptprocess/searchworkervchrs',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersearchworkervchrs(res, e) )
      .catch(err => console.log(err));
	  
}//end func

function aftersearchworkervchrs(res, e){

if (e)
	cssclass(e.target.id, "hidden", 0);
	
	if (!res.length)
		return;
	
let temparrdoc=[];	
	
res.map((col, index) => {
		let DATE_PAID=col['DATE_PAID']==null?"":col['DATE_PAID'];
		
		temparrdoc.push({
			DOC_NO: col['DOC_NO']
			,TRANS_DATE: col['TRANS_DATE']
			,CLI_TRANS_DATE: col['CLI_TRANS_DATE']
			,CLI_DATE_PAID: col['CLI_DATE_PAID']
			,AMOUNT: col['AMOUNT']
			,DATE_PAID: DATE_PAID
			,ACCT_DESCP_1: col['ACCT_DESCP_1']
			,DOC_STATE: col['DOC_STATE']
			,RECEIPT_VOUCHER_COMMENT: col['RECEIPT_VOUCHER_COMMENT']
			});
		
		});//end map	


setArrsearchdocs(temparrdoc);

}//end func

function writetbldocno(){

let htmrows=[];
arrsearchdocs.map((col, index) => {
	
	const key="tblvchrs_"+index;
	const docNo=col['DOC_NO'];
	const downloadLink=<a href="#" className="nodecor" id={"link_"+index} onClick={(e)=>{makevchrpdffile(e, index);}} ><img src='img/pdf.gif' border='0' />&nbsp;{docNo}</a>;
	
	const htmrow=<tr key={key} >
	
		<td align="right" >{index+1}&nbsp;</td>
		<td align="center" className="hand" onClick={(e)=>{doSetDocsearchcrit(col['CLI_TRANS_DATE']); }} >{col['TRANS_DATE']}</td>
		<td align="left" >{downloadLink}</td>
		<td className="tlnrgt" >{col['AMOUNT']}</td>
		<td align="center" className="hand" onClick={(e)=>{doSetDocsearchcrit(col['CLI_DATE_PAID']); }}  >{col['DATE_PAID']}</td>
		<td align="left" >{col['ACCT_DESCP_1']}</td>
		<td align="left" >{col['DOC_STATE']}</td>
		<td align="left" ><textarea className="gnsbro" readOnly rows="1" cols="60" >{col['RECEIPT_VOUCHER_COMMENT']}</textarea></td>
		</tr>;
		
	htmrows.push(htmrow);
		
	});//end map

setTbldocno(htmrows);	
}//end func

function doSetDocsearchcrit(date1){
	//showsnackbar("date filter: "+date1);
	console.log("doSetDocsearchcrit: "+date1);

	setDocsearchcrit((prev)=>{
		return {...prev, date:date1}
		});


}//end func


/*
async function fixrenewallbrclrdates(e) {
	if (e)
		e.preventDefault();
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {LBR_CLR_APP_ID: wptapp.IPM_LBR_CLR_APP_ID} )
  };		
	if (!e.target.classList.contains("hidden"))
		e.target.classList.add("hidden");


  await fetch(resturl+'rarwpform/fixrenewallbrclrdates',requestOptions)
	  .then(res => res.json())
      .then(res => 	after_fixrenewallbrclrdates(e, res) )
      .catch(err => console.log(err));
	  
}//end func

function after_fixrenewallbrclrdates(e, res){
		if (e.target.classList.contains("hidden"))
		e.target.classList.remove("hidden");
	
	console.log("after_fixrenewallbrclrdates: "+JSON.stringify(res))
	
	const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;
	if (UPDATE_COUNT==0)
		showsnackbar("operation failed");
	else{
		showsnackbar("done!");
		setWptapp((prev)=>{
			return {
				...prev
				, WRK_PMT_EXPIRE_DATE: res[0].WRK_PMT_EXPIRE_DATE
				, CON_START_DATE: res[0].CON_START_DATE
				, CON_END_DATE: res[0].CON_END_DATE
				, DATE_ISSUED: res[0].DATE_ISSUED
				, EXP_DATE: res[0].EXP_DATE
				, SHOW_FIX_DATES: 0
				}
			});
		}//end else
	
}//end func
*/

async function get_remote_lc_app_decsn(e) {
	if (e)
		e.preventDefault();
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {lbr_clr_app_id: wptapp.IPM_LBR_CLR_APP_ID} )
  };		
	if (!e.target.classList.contains("hidden"))
		e.target.classList.add("hidden");


  await fetch(resturl+'rarwptprocess/get_remote_lc_app_decsn',requestOptions)
      .then(res => 	after_get_remote_lc_app_decsn(e, res) )
      .catch(err => console.log(err));
	  
}//end func


async function after_get_remote_lc_app_decsn(e, res){

	if (e.target.classList.contains("hidden"))
		e.target.classList.remove("hidden");
	
	await tbllbrclrappdecision();
	showsnackbar("done!");
	
}//end func

async function rptwptcardxml(e) {
	if (e)
		e.preventDefault();
	
	if (wptapp.STATUS!="APPROVED"){
		window.alert("It must be approved");
		return;
		}	
	
	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, WORK_PERMIT_ID: wptapp.WORK_PERMIT_ID
		};
	//{  }
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

	if (e.target)
		e.target.style.visibility='hidden';


  await fetch(resturl+'rarwptprocess/rptwptcardxml',requestOptions)
      .then(res => 	afterrptwptcardxml(res, e) )
      .catch(err => console.log(err));
	  
}//end func

async function afterrptwptcardxml(res, e){
	//application/vnd.openxmlformats-officedocument.wordprocessingml.document
	const filename="WorkPermitCardLetter"+wptapp.WORK_PERMIT_NO+".docx";
	const blob = await res.blob();
	saveAs(blob, filename);
	if (e.target)
		e.target.style.visibility='visible';
	
}//end func


function afterupdatelbrclrapp(res){
	
	document.getElementById('btnsave').style.visibility="hidden";
	document.getElementsByName('DEC_ID')[0].style.visibility="visible";
	//console.log(JSON.stringify(res));
	
	const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;
	
	if (UPDATE_COUNT>0){
		showsnackbar("# of rows updated: "+UPDATE_COUNT);
		//get_labr_clr_app();
		getlbrclrorwptapp(wptapp.IPM_LBR_CLR_APP_ID?wptapp.IPM_LBR_CLR_APP_ID:0, wptapp.WPT_APP_ID?wptapp.WPT_APP_ID:0);
		}
	else
		showsnackbar("something went wrong.  please try again");
}//end func

function critChange(e){
		var {name, value}=e.target;
console.log("handleChange name: "+name+" -> "+value);	
//document.getElementById('btnsave').style.visibility='visible';
if (name=="apptype" && value=="board"){
	sessionStorage.setItem("XTL_NAME", "Board");
	sessionStorage.setItem("START_PAGE", "lbr_clr_xtl");
	navigate("/lbr_clr_xtl");
	}//end if

if (name=="filteruser")
	value=(e.target.checked)?value:"";

setSearchcrit((prev)=>{
	return {...prev, [name]:value}
});


}//end func


function focusComments(e){
	e.target.select();
	showCheckboxes(false);
}//end func

function showBtnsave(){
	//console.log("showBtnsave 1");
	
	if (document.getElementById('btnsave'))
		document.getElementById('btnsave').style.visibility="visible";
	
	if (document.getElementsByName('DEC_ID')[0])
		document.getElementsByName('DEC_ID')[0].style.visibility="hidden";

}//end func

function backPage(e){
e.preventDefault(); 

const BACK_PAGE=location.state?(location.state.BACK_PAGE??""):"";

console.log("BACK_PAGE: "+BACK_PAGE);

if (BACK_PAGE==""){
	setArrsearchdocs([]);
	setTbldocno([]);	
	setTbllbrclrdecision([]);
	showCheckboxes(false);
	
	setWptapp((prev)=>{
		return {...prev, IPM_LBR_CLR_APP_ID:"", WPT_APP_ID:""}
	});	
	cbbalrcp_uncheck(null);
	openCity(null, "tbllaborclr");
	//document.getElementById("tblmain").scrollIntoView();
	}//end if
else
	navigate("/"+BACK_PAGE, {state:{WPT_APP_ID:wptapp.WPT_APP_ID}});
	
}//end func




function nextlbrclrlistitem(e){
e.preventDefault();
const combolbrclrlist = document.getElementById("combolbrclrlist");
const index=combolbrclrlist.selectedIndex;
console.log("nextlbrclrlistitem: "+index);
//combolbrclrlist.selectedIndex=index+1;
const nextId=combolbrclrlist.options[index+1].value;
setWptapp((prev)=> {return {...prev, IPM_LBR_CLR_APP_ID:nextId}});
		
}//end func


function writeClipboard(e, text1){
if (e)
	e.preventDefault();
/* var  text1= "Example text to appear on clipboard"; */
navigator.clipboard.writeText(text1).then(function() {
  //console.log('Async: Copying to clipboard was successful!');
  showsnackbar(text1+" was copied to clipboard");
}, function(err) {
  console.error('Async: Could not copy text: ', err);
});	
	
}//end func


async function openScans (e, filename) {
e.preventDefault();

const relFilepath=wptapp.REF_NUM+"/"+filename;
const params={
	filepath:relFilepath
	, TBL: "WPT"
	, WPT_APP_ID: wptapp.WPT_APP_ID
	, AD_USER:sessionStorage.getItem("AD_USER")
	, FILENAME: filename
	, FLAG_DL: 1
	};
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

	if (filename=="latescan.pdf")
		setLatedlwait({show:true});
	else
		setDlwait({show:true});

  fetch(scansurl+'rarwpform/getwptappfile',requestOptions)
      .then(res => afteropenScans(res, filename))
      .catch(err => console.log(err));


}//end func

async function afteropenScans(res, filename){
const downloadFilename = wptapp.REF_NUM+"_"+filename;
const blob = await res.blob();
//console.log('blob.length: '+blob.length);
const data = window.URL.createObjectURL(new Blob([blob]));

const link = document.createElement("a");
link.href = data;
link.setAttribute("download", downloadFilename);
document.body.appendChild(link);
link.click();
//link.parentNode!.removeChild(link);	
link.parentNode?.removeChild(link);	


if (filename=="latescan.pdf")
	setLatedlwait({show:false});
else
	setDlwait({show:false});


}//end func

function gotoWorkPermit(e){
	e.preventDefault();
	
	if (1>0)
		return;
	
	if (wptapp.WORK_PERMIT_ID>0){
		var IPM_LBR_CLR_APP_ID=wptapp.IPM_LBR_CLR_APP_ID, WPT_APP_ID=0;
		if (location.state){
			if (location.state.IPM_LBR_CLR_APP_ID)
				IPM_LBR_CLR_APP_ID=location.state.IPM_LBR_CLR_APP_ID;
			if (location.state.WPT_APP_ID)
				WPT_APP_ID=location.state.WPT_APP_ID;
			
			}
			
		navigate("/wptprocess", {state:{WORK_PERMIT_ID:wptapp.WORK_PERMIT_ID, IPM_LBR_CLR_APP_ID:IPM_LBR_CLR_APP_ID, WPT_APP_ID:WPT_APP_ID}});
		}//end if
	else{
		const result=window.confirm("No Work Permit is linked to this Labour Clearance.\r\nCreate a Work Permit record?");
		if (result==true)
			getworkpermitforexport();
		}
}//end func


async function clickReprintRcp(e){
cssclass(e.target.id, "hidden", 1);
const confirmed = window.confirm("will check if the print server is online.\r\nAfter that, click the pdf icon for the receipt");


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID:wptapp.WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")} )
  };		

	setDowait({show:true});

  await fetch(customspremurl+'rarvchrpdffile/dbtest',requestOptions)
      .then(res => res.json())
      .then(res => 	afterdbtest(e, res, null) )
      .catch(err => afterdbtest(e, null, err));

}//end func

function afterdbtest(e, res, err){
	setDowait({show:false});
cssclass(e.target.id, "hidden", 0);	

if (err){
	e.target.checked=false;
	console.log(err);
	window.alert("Sorry: the receipt print server seems to be unavailable");
	return;
	}

const QUERY_COUNT=res.length?(res[0].QUERY_COUNT??0):0;
if (QUERY_COUNT==0){
	window.alert("Sorry: the receipt print server seems to be unavailable");
	e.target.checked=false;
	}
else
	showsnackbar("Server ready! click the pdf icon for the receipt and wait");
}//end func


function clickAddBalRcp(e){

console.log("clickAddBalRcp wptapp.WPT_APP_ID: "+wptapp.WPT_APP_ID);

if (e.target.checked==true && !wptapp.WPT_APP_ID)
	fake_lbrclr_wptapp(e);
else
	setCbbalrcp({checked:e.target.checked});
	
}//end func

{/*
<input name='STATUS' value={wptapp.STATUS} onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{handleFocus(e);}} autoComplete='off' />
*/}


const SUBMITTED_TO_CSC=wptapp.SUBMITTED_TO_CSC??"";

const tblfields=<>
	<form id='form1' method='POST' onSubmit={(e)=>{submitform1(e);}} >
	<table align='center' border="0" width="100%"  >
	<tbody  >
	
	<tr valign="top" >
		<td align='right' >
		<span title="click to copy Employer Id" onClick={(e)=>{writeClipboard(e, wptapp.EMPL_ID);}} className="hand" >{wptapp.EMPL_ID}</span>
		&nbsp;&nbsp;Employer:
		</td>
		<td align='left' ><input name='MPR_NAME' defaultValue={wptapp.MPR_NAME} readOnly className="gnsbro"  onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Applicant/Worker:</td>
		<td align='left' >
			<input name='MPE_NAME' defaultValue={wptapp.MPE_NAME} readOnly className="gnsbro"  onFocus={(e)=>{handleFocus(e);}} autoComplete='off' />
			&nbsp;<a href="#" title={"DOB: "+wptapp.TC_DOB} onClick={(e)=>{writeClipboard(e, wptapp.TC_DOB);}} ><img src="img/calend.png" height="16" border="0" /></a>
		</td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='left' rowSpan="4" ><textarea name="COMMENTS" id="comboticksresult" value={wptapp.COMMENTS?? ""} onChange={(e)=>{handleChange(e);}} cols="38" rows="6" onFocus={(e)=>{focusComments(e);}} placeholder="Comments" ></textarea></td>
		
	</tr>


	<tr>
		<td align='right' >
			<a href="#" id="btnletter" title="download pdf letter" onClick={(e)=>{letterforlbrclr(e, false);}} ><img src="img/printer.png" height="18" border="0"  /></a>
			&nbsp;&nbsp;Status:
		</td>
		<td align='left' >
			<select name="APP_STATUS_ID" title={"APP_STATUS_ID: "+(wptapp.APP_STATUS_ID?? "")} value={wptapp.APP_STATUS_ID?? ""} onChange={(e)=>{handleChange(e);}} style={{width:"180px"}} >
			{laborclrstatus}
			</select>
		</td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >
			{
			wptapp.WEB_USER_EMAIL=="" && (wptapp.APP_STATUS_ID==2||wptapp.APP_STATUS_ID==3) &&
			<img src="img/redalert.png" border="0" height="18" title="this application has no email address" />
			}
			{/*
			wptapp.LBR_CLR_APPROVER_BUTTON==1 &&
			<a href="#" ><img src="img/approvebutton.png" height="22"  border="0" title="Approve Labour Clearance" /></a>
			*/}
			&nbsp;Decision:
		</td>
		<td align='left' >
		<select name="DEC_ID" value={wptapp.DEC_ID?? "" }  onChange={(e)=>{handleChange(e);}}  >
		<option value='' ></option>
		{decisionoptions}
		</select>	
		{/*
		&nbsp;&nbsp;Empl. Id:
		<input name='EMPL_ID' title="Employer Id" defaultValue={wptapp.EMPL_ID} readOnly className="gnsbro" style={{textAlign:"center"}} size="5" onFocus={(e)=>{handleFocus(e);}} autoComplete='off' />
		*/}
		</td>
	</tr>
	<tr>
		<td align='right' >Immig. Ref. #:</td>
		<td align='left' >
			<input name='IMG_REF_NO' title="Immig. Ref. #" value={wptapp.IMG_REF_NO?? ""} onChange={(e)=>{handleChange(e);}} size="6" onFocus={(e)=>{handleFocus(e);}} autoComplete='off' />
			&nbsp;&nbsp;&nbsp;
			<input name='PERSON_ID' title="Person Id" defaultValue={wptapp.PERSON_ID} readOnly className="gnsbro" size="5" onFocus={(e)=>{handleFocus(e);}}  style={{textAlign:"center"}} autoComplete='off' />
		</td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Medical Issue:</td>
		<td align='left' ><input name='MED_CERT_ISSUE_DATE' type="text" size="10"  type="date" value={wptapp.MED_CERT_ISSUE_DATE?? ""} onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{handleFocus(e);}}  /></td>
	</tr>

	<tr>
		<td align='right' >App. Type:</td>
		<td align='left' >
			<select  name='APP_TYPE_ID' value={wptapp.APP_TYPE_ID?? ""} onChange={(e)=>{handleChange(e);}} >
			{combotype}
			</select>
			
		</td>	
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Medical Expire:</td>
		<td align='left' ><input name='MED_CERT_EXPIRE_DATE' type="text" size="10"  type="date" value={wptapp.MED_CERT_EXPIRE_DATE?? ""} onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{handleFocus(e);}} /></td>
	</tr>

	<tr>
		<td align='right' >Location: </td>
		<td align='left' >
			
			<select name="LOCATION_ID" value={wptapp.LOCATION_ID?? ""} onChange={(e)=>{handleChange(e);}} >
			{locationoptions}
			</select>
		</td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Occupation:</td>
		<td align='left' >
			<select  name='OCCUPATION_ID' value={wptapp.OCCUPATION_ID?? ""} required onChange={(e)=>{handleChange(e);}} style={{width:"200px"}} >
			<option value="" ></option>
			{occupationoptions}
			</select>
		</td>


		<td align='center' width="20" >&nbsp;</td>
		<td align='left' >
		<div className="multipleSelection">
			<table>
			<tbody>
				<tr>
				<td align='center' >
				<div className="selectBox" onClick={(e)=>{showCheckboxes(null);}} >
					<select style={{width:"200px"}} >
						<option>Preset Comments</option>
					</select>
					<div className="overSelect"></div>
				</div>
				</td>
				<td align='center' >
				<a href='#' id='btnclosecb' onClick={(e)=>{e.preventDefault(); showCheckboxes(false);}}  >[close]</a>
				</td>
				</tr>
			</tbody>
			</table>
		<div id="checkBoxes" >
		{arrcheckbox}
		</div>
		</div>
		</td>

	</tr>
	<tr>
		<td align='right' >Agency: </td>
		<td align='left' >
		<select name="AGENCY_ID" value={wptapp.AGENCY_ID?? "" } required onChange={(e)=>{handleChange(e);}} style={{width:"180px"}} >
		{agencyoptions}
		</select>
		</td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Contract Start:</td>
		<td align='left' ><input name='CON_START_DATE' type="text" size="10" type="date" required value={wptapp.CON_START_DATE?? ""} onChange={(e)=>{handleChange(e);}}  /></td>
		
		<td align='center' width="20" >&nbsp;</td>
		<td align='left' rowSpan="6" >
		{/*
		2026-01-13 removed BOARD_REMARKS to put headshot
		<textarea name="BOARD_REMARKS"  value={wptapp.BOARD_REMARKS?? ""} onChange={(e)=>{handleChange(e);}} cols="38" rows="6" onFocus={(e)=>{focusComments(e);}} placeholder="Board Remarks" ></textarea>
		*/}
		{wptapp.REF_NUM!=undefined && <>
		<img src={resturl+"rarwpform/getwptappfoto?path="+wptapp.REF_NUM+"/foto.png"} border='0' height="150" />
		</>
		}
		</td>


		
	</tr>
	<tr>
		<td align='right' >Salary (US $):</td>
		<td align='left' ><input name='SALARY_WAGES' required value={wptapp.SALARY_WAGES?? ""} size="9" onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Contract End:</td>
		<td align='left' ><input name='CON_END_DATE' type="date" required value={wptapp.CON_END_DATE?? ""} onChange={(e)=>{handleChange(e);}} /></td>
	</tr>
	<tr>
		<td align='right' >Salary Period:</td>
		<td align='left' >
			<select name='WAGE_DENOM' value={wptapp.WAGE_DENOM} required onChange={(e)=>{handleChange(e);}} >
			<option value='' ></option>
			{payperiodoptions}
			</select>
		</td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Clearance Issue:</td>
		<td align='left' ><input name='DATE_ISSUED' required value={wptapp.DATE_ISSUED?? ""}  type="date" onChange={(e)=>{handleChange(e);}}  /></td>
	
	</tr>

	<tr>
		<td align='right' >Date Received:</td>
		<td align='left' ><input name='APP_DATE' required value={wptapp.APP_DATE?? ""}  type="date" onChange={(e)=>{handleChange(e);}} /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Clearance Expire:</td>
		<td align='left' ><input name='EXP_DATE' required value={wptapp.EXP_DATE?? ""}  type="date" onChange={(e)=>{handleChange(e);}}  /></td>

	</tr>



	<tr>
		<td align='right' >Board Approval:</td>
		<td align='left' >
			<input name="REQ_BOARD_APPROVAL" size="2" value={wptapp.REQ_BOARD_APPROVAL?? "" } readOnly className="gnsbro" />
				{/*
			<select name="REQ_BOARD_APPROVAL" value={wptapp.REQ_BOARD_APPROVAL?? "" } required onChange={(e)=>{handleChange(e);}}  >
			{yesnooptions}
			</select>
			&nbsp;&nbsp;
				*/}
		</td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Work Permit Expired: </td>
		<td align='left' >
			<input value={wptapp.WRK_PMT_EXPIRE_DATE?? "" } disabled type="date"  />
			{/*
			wptapp.SHOW_FIX_DATES=="1" &&
			<a href="#"  onClick={(e)=>{fixrenewallbrclrdates(e);}}className="nodecor" title={wptapp.WRK_PMT_EXPIRE_DATE} ><img src="img/hammer.png" border="0" height="16" /> fix dates</a>
			*/}
		</td>

		{/*
		<td align='right' >Intel Cleared: </td>
		<td align='left' ><input value={wptapp.STR_INTEL_CLEARED?? "" } size="9" readOnly className="gnsbro"  /></td>
		
		*/}
	</tr>


	<tr>
		<td align='right' >Medical Received: </td>
		<td align='left' >
		<select name="MED_REC" value={wptapp.MED_REC?? "" } required onChange={(e)=>{handleChange(e);}}  >
		{yesnooptions}
		</select>	
		</td>
		<td align='center' width="20" >&nbsp;</td>

		<td align='right' >Duration Requested: </td>
		<td align='left' ><input value={wptapp.WRK_PMT_DURATION?? "" } size="12" readOnly className="gnsbro"  /></td>
		{/*
		<td align='right' >Intel Cleared Date: </td>
		<td align='left' ><input value={wptapp.TC_INTEL_DATE?? "" } size="15" readOnly className="gnsbro"  /></td>
		
		*/}
	</tr>

	

	
	<tr valign="top" >
		<td align='right' >{wptapp.SWITCHED_MPR==1 && <img src="img/redalert.png" height="18" border="0" title="siwtched employer" />} Last Employer:</td>
		<td align='left' ><input defaultValue={wptapp.LAST_MPR_NAME } readOnly className="gnsbro" /></td>
		
		<td>&nbsp;</td>
		
		<td align='right' ><a href="#" onClick={(e)=>{ backPage(e); }} ><img src="img/return.png" border="0" /></a>&nbsp;&nbsp;</td>
		<td align='left' >&nbsp;&nbsp;
			{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{
			!dowait.show && 
			<button className='button' id='btnsave' style={{visibility:"hidden"}}    >save changes</button>
			}			
		
		</td>

		<td>&nbsp;</td>
		
		<td rowSpan="3" >
		{/*2026-01-13 removed vouchers from here and put APS Info*/}
		<fieldset>
		<legend>
			{
			SUBMITTED_TO_CSC!="" && <a href="#" title={wptapp.WPT_APP_ID} onClick={(e)=>{ e.preventDefault(); navigate("/wptform",{state:{WPT_APP_ID:wptapp.WPT_APP_ID}}); }} ><img src='img/folderyel.png' height='18' border='0' /></a>
			}
			&nbsp;APS Info with Ref # {SUBMITTED_TO_CSC!="" && wptapp.REF_NUM}
		</legend>
		{
		SUBMITTED_TO_CSC=="" && <div align="center">This application is not from APS</div>
		}
		{
		SUBMITTED_TO_CSC!="" && 
		<table align="center">
		<tbody>
		<tr>
			<td align='center' colSpan='2' style={{paddingBottom:"9px"}} >
			{dlwait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
			{!dlwait.show && <a href="#" onClick={(e)=>{openScans(e, "scans.pdf");}} className="nodecor" ><img src='img/pdf.gif' border='0' /> click here to see scanned documents</a>}
			</td>
		</tr>
			{
			wptapp.LATE_SCAN_SIZE>0 && 	
			<tr>
				<td align='center' colSpan='2' style={{paddingBottom:"9px"}} >
				{latedlwait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
				{!latedlwait.show && <a href="#" onClick={(e)=>{openScans(e,"latescan.pdf");}} className="nodecor" ><img src='img/pdf.gif' border='0' /> click here to see late scanned documents</a>}
				</td>
			</tr>
			}

			{
			wptapp.LC_APPEAL_PDF_SIZE>0 && 	
			<tr>
				<td align='center' colSpan='2' style={{paddingBottom:"9px"}} >
				{latedlwait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
				{!latedlwait.show && <a href="#" onClick={(e)=>{openScans(e,"labourscan.pdf");}} className="nodecor" ><img src='img/pdf.gif' border='0' /> click here to see appeal scanned document</a>}
				</td>
			</tr>
			}

			{
			wptapp.BAL_RCP_PDF_SIZE>0 && 	
			<tr>
				<td align='center' colSpan='2' style={{paddingBottom:"9px"}} >
				{latedlwait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
				{!latedlwait.show && <a href="#" onClick={(e)=>{openScans(e,"balrcpscan.pdf");}} className="nodecor" ><img src='img/pdf.gif' border='0' /> click here to see paid balance receipts</a>}
				</td>
			</tr>
			}

		<tr>
			<td align="right"  >Review Type:</td>
			<td align="left"  >
				<select name='REVIEW_TYPE'  value={wptapp.REVIEW_TYPE} onChange={(e)=>{boardChange(e);}} >
				<option value='' ></option>
				{reviewtypeoptions}
				</select>
				&nbsp;&nbsp;
				<a href="#" onClick={(e)=>{updatereviewtype(e);}} id="btnreviewtype" className="hidden" title="save changes"  ><img src="img/floppysm.png" border="0"  /></a>
				
			</td>
		</tr>			
		
		</tbody>
		</table>
		}
	
		</fieldset>

		</td>
	</tr>
	<tr>
		<td align='right' >Create Date:</td>
		<td align='left' ><input name='CREATE_DATE' defaultValue={wptapp.CREATE_DATE} type='text'  onFocus={(e)=>{handleFocus(e);}} autoComplete='off' readOnly className="gnsbro" /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Update Date:</td>
		<td align='left' ><input name='MODIFY_DATE' defaultValue={wptapp.MODIFY_DATE} type='text'  onFocus={(e)=>{handleFocus(e);}} autoComplete='off' readOnly className="gnsbro"  /></td>
	</tr>
	<tr>
		<td align='right' >Create User:</td>
		<td align='left' ><input name='CREATE_USER' defaultValue={wptapp.CREATE_USER} type='text'  onFocus={(e)=>{handleFocus(e);}} autoComplete='off' readOnly className="gnsbro"  /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Update User:</td>
		<td align='left' ><input name='MODIFY_USER' defaultValue={wptapp.MODIFY_USER} type='text'  onFocus={(e)=>{handleFocus(e);}} autoComplete='off' readOnly className="gnsbro"  /></td>
		
	</tr>
	

	</tbody>
	</table>
	</form>

	
	<table align="center" width="99%" border="0" >
	<tbody>
	<tr valign="top" >
	<td align="center" stlye={{width:"75%"}} >


		<div align="center" >
		<h4 align='center' className="Acme" style={{ marginBottom:"4px", color:"brown",fontSize:"18px"}} >
		Decisions Made for this Labour Clearance
		</h4>
		</div>
		<table align="center" className="customers" style={{width:"100%"}} >
		<thead>
		<tr>
		<th align='center' >Date</th>
		<th align='center' >Decision</th>
		<th align='center' >Comment</th>
		<th align='center' >User</th>
		<th align='center' >Reversed</th>
		<th align='center' >Reverse Reason</th>
		{/*
		<th align='center' ><a href="#" title="update from secondary" onClick={(e)=>{get_remote_lc_app_decsn(e);}} ><img src="img/refresh_green.png" border="0" height="18" /></a> Secondary {timeLeft}</th>
		*/}
		<th align='center' >Letter Emailed</th>
		</tr>
		</thead>
		<tbody>
		{tbllbrclrdecision}
		</tbody>
		</table>
		
		{
		combosearchresapps.length>1 &&
		<p align="center" ><br/>
		{combosearchresapps.length} Search Results Applications
		<table align="center" >
		<tbody>
		<tr>
		<td align="center" ><a href="#" id="btnprevsearchapp" onClick={(e)=>{nextsearchresapp(e,0);}} title="previous application" ><img src="img/prev.png" border="0" /></a></td>
		<td align="center" >
			<select id="combosearchresapps" value={wptapp.WPT_APP_ID}  onChange={(e)=>{searchresappsChange(e);}} >{combosearchresapps}</select>
		</td>
		<td align="center" ><a href="#" id="btnnextsearchapp" onClick={(e)=>{nextsearchresapp(e,1);}} title="next application" ><img src="img/next.png" border="0" /></a></td>
		</tr>
		</tbody>
		</table>
		</p>
		}
		
	
	</td>
	<td align="center"  stlye={{width:"25%"}} >


				
				<h4 align="center" className="Acme" style={{marginBottom:"4px", color:"brown",fontSize:"18px"}} >
				Vouchers
				</h4>

	 
			<table align="center" className="customers" width="100%" id="tblvouchers" >
			<thead>
			<tr>
				<th align="center" >Doc. No</th>
				<th align="center" >Amount</th>
				<th align="center" >Created</th>
				<th align="center" >Paid</th>
			</tr>
			</thead>
			<tbody>
			{tblvoucher}
			</tbody>
			</table>
				<div align='center'  style={{marginBottom:"6px", marginTop:"9px"}} >
				{
					wptapp.APP_STATUS_ID=="1" && <>
					<input type="checkbox" id="cbbalrcp" onClick={(e)=>{ clickAddBalRcp(e); }} />
					<label htmlFor="cbbalrcp" className="hand" >add balance receipts</label>
					 </>
					 
				}
				</div>
				<div align='center'  style={{marginBottom:"6px", marginTop:"9px"}} >
				<input type="checkbox" id="cbprintpaidrcp" onClick={(e)=>{ clickReprintRcp(e); }} />
				<label htmlFor="cbprintpaidrcp" className="hand" >print a paid receipt</label>
				</div>
			

				<h4 align="center" className="Acme" style={{marginBottom:"4px", color:"brown",fontSize:"18px"}} >
				Endorsements
				</h4>			
		<table align='center' className="customers" >
		<tbody>
		<tr>
			<th align="center">Id</th>
			<th align="left">Edorsee's Name</th>
			<th align="left">Gender</th>
			<th align="left">DOB</th>
			<th align="left">National.</th>
			<th align="left">Approv.</th>
		</tr>
		</tbody>

		<tbody>
		{tblendorsee}
		</tbody>

		</table>
		<p>
		<a href="#" onClick={(e)=>{insertwptappendorsee(e);}} >update table</a>
		<br/><input value={wptapp.ENDORSEMENTS} readOnly className="gnsbro" size="3" />
		</p>
		
			
			{/*
			<div align="center" style={{marginTop:"8px"}} >
				<button className="button" onClick={(e)=>{createWorkPermitApp(e);}} >create work permit application</button>
			</div>

			*/}
			<div align="center" >
				<a href="#" id="btnsavedocno" onClick={(e)=>{savedocno(e);}} className="nodecor" style={{visibility:"hidden"}} ><img src="img/floppysm.png" border="0" height="16" /> save document numbers</a>
			</div>

	</td>
	</tr>
	</tbody>
	</table>

		
	
	
	
	
	</>;

const username=sessionStorage.getItem("USERNAME");
let WPT_APP_ID=0;
if (wptapp.WPT_APP_ID)
	if (wptapp.WPT_APP_ID>0)
		WPT_APP_ID=wptapp.WPT_APP_ID;
	
	
function createWorkPermitApp(e){
	e.preventDefault();
	/*
	this feauture wil be for APS apps only
	*/
	alert("feature is not avaiable as yet");
}//end function


/*
createwptapp req.body.mpe: {"IMG_REF":"E1954","DOB":"15.Aug.1979","FIRST_NAME":"Robert","FOTO_SIZE":295,"HLD_PVS_WPT":"1","SKIP_IMG_REF_LOOKUP":false,"IMG_REF_TIP":true}
createwptapp req.body.mpr: {"EMPL_ID":"87846","GOVT":0,"COMPANY":"Magic mirror Beauty Salon"}
createwptapp req.body.wptapp: {"WPT_APP_ID":null,"REF_NUM":"CCB01kw","APP_TYPE_ID":"2","TC_ISLAND":"PROVIDENCIALES","CASE_WORKER":"","PROCESS_AREA":"General"}
*/



function tblvouchers(){
	return <>
	</>;
	{/*
	<fieldset className="fieldsetlg" style={{width:"85%",marginTop:"12px"}} >
	<legend>Payment Vouchers {wptapp.IPM_LBR_CLR_APP_ID}
	<a href="#" onClick={(e)=>{writeClipboard(e, wptapp.IPM_LBR_CLR_APP_ID);}} title="click to copy ID" ><img src="img/copy.png" height="18" border="0" /></a>
	</legend>
	<table align="center" border="0" width="95%" >
	<tbody>
	<tr>
		<td align='right' >Update User:</td>
		<td align='right' ><input name='EXP_DATE' required value={wptapp.EXP_DATE?? ""}  type="date" onChange={(e)=>{handleChange(e);}}  /></td>
	</tr>
	</tbody>
	</table>
	</fieldset>	
	
	*/}	
	
}//end func	



function handleVoucherChange(e, index){

	console.log('handleVoucherChange index:'+index);
	
	let tempudak=udak;
	if (e.target.name=='VCHR_COMMENT[]')
		tempudak[index].VCHR_COMMENT=e.target.value;
	else
		tempudak[index].AMOUNT=e.target.value;
	
	setUdak(tempudak);
	
	showbtnsavevchrchanges();
	
}//end func

function showbtnsavevchrchanges(){
	if (document.getElementById('btnsavevchrchanges'))
		document.getElementById('btnsavevchrchanges').style.visibility='visible';
	if (document.getElementById('btinsertprepdoc'))
		document.getElementById('btinsertprepdoc').style.visibility='hidden';
	if (document.getElementById('btnclearvchrtable'))
		document.getElementById('btnclearvchrtable').style.visibility='hidden';	
}//end func

function dosetTbludaklc(){
let lchtmrows=[];
let wphtmrows=[];
let lcnumcomments=0, wpnumcomments=0;
console.log('udak.length : '+udak.length);


udak.map((col, index) => {
	//console.log('dosetTbludaklc col: '+JSON.stringify(col));
	const trkey='tr_'+index;
	const tdkey='td_'+index;
	const typ=col.VCHR_TYPE;
	//console.log('vchr_type:'+typ);
	//const doclink=(col.docno==null)?<></>:<a href={"https://customsprem.gov.tc/webuploads/voucher/"+col.docno+".pdf"} target="_none" >{col.docno}</a>;
	let htmrow=[];
	htmrow.push(<tr key={trkey} >
	<td align='center'   >{col.ACCOUNT}</td>
	<td align='center'   ><input type="text" name={typ+'AMT[]'}  autoComplete='off'  defaultValue={col.AMOUNT} onChange={(e)=>{handleVoucherChange(e, index);}} onFocus={(e)=>{e.target.select();}} size="9" style={{textAlign:"right"}} /></td>
	<td align='left'   >{col.ACCT_DESCP_1}</td>
	<td align='center'   >{col.MODIFY_USER}</td>
	<td align='center'   >{col.CHR_MODIFY_DATE}</td>
	</tr>);
	
	if (udak[index].VCHR_COMMENT!=null ){
		htmrow.push(<tr key={trkey+"amt"}  >
		<td align='center' key={index+"c1"}  >&nbsp;</td>
		<td align='center' key={index+"c2"}  >&nbsp;</td>
		<td align='left'  key={index+"c3"} colSpan="3"  ><textarea name='VCHR_COMMENT[]' defaultValue={col.VCHR_COMMENT} onChange={(e)=>{handleVoucherChange(e, index);}} onFocus={(e)=>{e.target.select();}} rows="3" cols="80" ></textarea></td>
		</tr>);
		if (typ=='WP')
			wpnumcomments++;
	}//end if


	if (typ=='WP')
		wphtmrows.push(htmrow);
});
{/*
<td align='center' colSpan="1" ><input d defaultValue={udak[index].cmt} onChange={(e)=>{handleChange(e, index);}} onFocus={(e)=>{e.target.select();}} size="110" /></td>
*/}

setTbludakwp(wphtmrows);
setNumcomments({lc:lcnumcomments, wp:wpnumcomments});
}//end func



function gettblwptappudak(){

	if (!wptapp.WPT_APP_ID)
		return;
	
	let params=[];
	params.push({WPT_APP_ID:wptapp.WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")});
	//params.push();
	const state={};
	const props={func:"gettblwptappudak", params:params, state:state, vchroptions:vchroptions};
	voucherwork(props, location, navigate, window.confirm, showsnackbar, setUdak, setDowait, null);
	
}//end func


function getprepinsertdoc(e){
	let params=[];
	params.push({WPT_APP_ID:wptapp.WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME"), VCHR_TYPE:vchroptions.vchrtype });
	params.push({ SEQ_NO:udak[0].SEQ_NO, WPT_APP_ID:wptapp.WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")});
	//params.push();
	const state={WPT_APP_ID:wptapp.WPT_APP_ID,SCTN:'K',shownextbutton:1, SEQ_NO:udak[0].SEQ_NO, BACK_PAGE:"lbr_clr_app"};
	const props={func:"getprepinsertdoc", params:params, state:state, vchroptions:vchroptions};
	voucherwork(props, location, navigate, window.confirm, showsnackbar, setUdak, setDowait, null);
}//end func

function savechanges(){

	let params=[];
	params.push({
	udak:udak
	, WPT_APP_ID:wptapp.WPT_APP_ID
	, APP_TYPE_ID:wptapp.APP_TYPE_ID
	, WRK_PMT_STARTS:wptapp.WRK_PMT_STARTS
	, WRK_PMT_ENDS:wptapp.WRK_PMT_ENDS
	, SWITCH_EMPLOYER:vchroptions.switchmpr
	, LATE_FEE:vchroptions.latefee
	, USERNAME:sessionStorage.getItem("USERNAME")
	});
	//params.push();
	const state={};
	const props={func:"savechanges", params:params, state:state, vchroptions:vchroptions};
	voucherwork(props, location, navigate, window.confirm, showsnackbar, setUdak, setDowait, null);
	
}//end func

function clearwptappudak(e){
e.preventDefault();
	let params=[];
	params.push({VCHR_TYPE:"LC", WPT_APP_ID:wptapp.WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")});
	//params.push();
	const state={};
	const props={func:"clearwptappudak", params:params, state:state, vchroptions:vchroptions};
	voucherwork(props, location, navigate, window.confirm, showsnackbar, setUdak, setDowait, null);
	
}//end func	

function cbbalrcp_uncheck(e){
if (e)
	e.preventDefault();
if (document.getElementById("cbbalrcp")){
	document.getElementById("cbbalrcp").checked=true;
	document.getElementById("cbbalrcp").click();
	}//end if
}//end func	

	
const SUP_PVG=sessionStorage.getItem("SUP_PVG")?sessionStorage.getItem("SUP_PVG"):"";
	
  return (
    <>
	

<div id="tbllaborclr" className="tabcontent">
  
  <h4 align='center' className="Acme" style={{ marginBottom:"4px", color:"brown",fontSize:"22px"}} >
  Labour Clearance Applications
  </h4>  
  

  <table align="center" border="0" width="74%" style={{ marginTop:"9px", marginBottom:"9px" }} >
  <tbody>
  <tr>
	<td align="left"  >
		<a href="#" title="Letters" className="nodecor" onClick={(e)=>{e.preventDefault();navigate("/lbr_clr_letter");}} ><img src="img/letters.png" border="0" /> letters</a>
	</td>
	<td align="center"  >&nbsp;
	{/*
		<select onChange={(e)=>{getxlfilename(e, "rptlbrclrmonth");}} title="generate labour clearance report for selected month" >
		<option value='' >* * * report * * *</option>
		{pastmonths}
		</select>
	*/}
	</td>
	<td align="right"  >
		search criteria: <input name="txt" value={searchcrit.txt} onChange={(e)=>{critChange(e);}} size="35"  placeholder="ref#, passort, employer name, worker name"  onFocus={(e)=>{e.target.select();}} />
	</td>
	<td align="left"  >
		<input type="checkbox" id="cbfilterme" name="filteruser" defaultValue={username} onClick={(e)=>{critChange(e);}} /><label htmlFor="cbfilterme" className="hand" >filter {username}</label>
	</td>
	<td align="right"  >
		<a href="#" title="agencies" className="nodecor" onClick={(e)=>{e.preventDefault();navigate("/agencycsw");}} ><img src="img/agency.png" border="0" /> Case Workers</a>
	</td>
  </tr>
  </tbody>
  </table>
  
  

	<table align='center' className='customers'  >
	<tbody>
	<tr>
	<th>#</th>
	<th>Labour<br/>Clr. Id</th>
	<th>
		<select name="office" value={searchcrit.office} onChange={(e)=>{critChange(e);}}  >
		<option value='' >Zone</option>
		<option value='Providenciales' >PLS</option>
		<option value='Grand Turk' >GT</option>
		</select>
	</th>	
	<th>update<br/>date</th>
	<th>update<br/>user</th>
	<th>APS<br/>Ref. #</th>
	<th>Immigr.<br/>Ref. #</th>
	<th>Employee</th>
	<th>
		<select name="apptype" value={searchcrit.apptype} onChange={(e)=>{critChange(e);}} style={{width:"70px"}} >
		<option value='' >***Type***</option>
		{combotype}
		</select>
	</th>
	<th>
		<select name="appstatus" value={searchcrit.appstatus} onChange={(e)=>{critChange(e);}} style={{width:"110px"}} >
		<option value='' >***Status***</option> 
		{laborclrstatus}
		</select>
	</th>
	<th>Occupation</th>
	<th>
		<select name="reqboardapprov" value={searchcrit.reqboardapprov} onChange={(e)=>{critChange(e);}} style={{width:"25px"}} >
		<option value='' >Review Type</option>
		<option value='1' >Board</option>
		<option value='0' >Commissioner</option>
		</select>	
	</th>
	<th>
		<select name="endorsement" value={searchcrit.endorsement} onChange={(e)=>{critChange(e);}} style={{width:"70px"}} >
		<option value='' >endorsement</option>
		<option value='1' >Yes</option>
		<option value='0' >No</option>
		</select>
	</th>
	<th>Employer</th>
	</tr>
	</tbody>
	<tbody>

  	{dowaittbl.show && <tr><td align="center" colSpan="9" ><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</td></tr>}
	{
	!dowaittbl.show && <>	
	{tbllaborclr}
	</>
	}
	</tbody>
	</table>
</div>	
	
	
<div id="currlaborclr" className="tabcontent">
	

	
				{
			cbbalrcp.checked==true && <>
			<table align='center' style={{width:"55%"}}  border="0" >
				<tbody>
				<tr>
				<td align='center'>
				&nbsp;&nbsp;
				</td>
				<td align='center' style={{width:"75%"}}  >
				<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >
				Create Balance Receipts
				</p>
				</td>
				<td align='center'>
				<a href="#" onClick={(e)=>{cbbalrcp_uncheck(e);}} >close this window</a>
				</td>
				</tr>
				</tbody>
			</table>
			<table align="center" className="customers" style={{width:"65%"}} >
			<thead>
			<tr>
				<th align="center" >acc code</th>
				<th align="center" >amount to be paid</th>
				<th align="center" >account description</th>
				<th align="center" >updated by</th>
				<th align="center" >updated</th>
			</tr>
			</thead>
			<tbody>
			{tbludakwp.length>0 && tbludakwp}
			</tbody>
			</table>
			<table align="center">
			<tbody>
			<tr>
				<td align="center" >
					approve&nbsp;
					<select name="WRK_PMT_NUM_YRS" value={wptapp.WRK_PMT_NUM_YRS} onChange={(e)=>{handleChange(e);}} >
					<option value='1'>1</option>
					<option value='2'>2</option>
					<option value='3'>3</option>
					</select>
					&nbsp;year(s) from <input type='date' name='WRK_PMT_STARTS' value={wptapp.WRK_PMT_STARTS?? "" } onChange={(e)=>{handleChange(e);}} /> 
					&nbsp;to <input type='date' name='WRK_PMT_ENDS' value={wptapp.WRK_PMT_ENDS?? "" } onChange={(e)=>{handleChange(e);}} />
				</td>
			</tr>
			</tbody>
			</table>
			
		<p align='center' >  		
				{dowait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
				
				{
				!dowait.show && 
				<input type="button" id='btnsavevchrchanges' className="button" value="save changes" onClick={(e)=>{ savechanges(); }}  />
				}

				{!dowait.show && udak[0]?.AMT_WITHOUT_DOC_NO>0 && vchroptions.vchrtype!='' && <>
				<a href='#' onClick={(e)=>{clearwptappudak(e);}} id="btnclearvchrtable" className="nodecor" ><img src='img/noicon.png' border='0' /> clear the table</a>
				&nbsp;&nbsp;&nbsp;&nbsp;
				<input type="button" id='btinsertprepdoc' className="button" value="create payment vouchers" onClick={(e)=>{ getprepinsertdoc(e);  }}  />
				</>
				}
		</p>
	
			</>
			}
	
	<fieldset className="fieldsetlg" style={{width:"95%",marginTop:"12px"}} >
	
	{wptapp.IPM_LBR_CLR_APP_ID==0 && <legend>Labour Clearance Id will generate after completing this form</legend>}
	{wptapp.IPM_LBR_CLR_APP_ID>0 && 
		<legend>
		Labour Clearance with ID {wptapp.IPM_LBR_CLR_APP_ID}
		&nbsp;&nbsp;<a href="#" onClick={(e)=>{writeClipboard(e, wptapp.IPM_LBR_CLR_APP_ID);}} title="click to copy ID" ><img src="img/copy.png" height="18" border="0" /></a>
		</legend>
	}
	
{/*
cswkrlbrclrlist.length>0 &&
<div align="center">	
	{cswkrlbrclrlist.length} Incomplete: <select id="combolbrclrlist" value={wptapp.IPM_LBR_CLR_APP_ID} onChange={(e)=>{ setWptapp((prev)=> {return {...prev, IPM_LBR_CLR_APP_ID:e.target.value}}); }} style={{width:"360px"}} >
	{cswkrlbrclrlist}
	</select>
	&nbsp;<a href="#" onClick={(e)=>{ nextlbrclrlistitem(e);}} >next</a>
</div>
*/}
	
	
	
	<table align="center" border="0" width="100%" id="tblmain" >
	<tbody>
	<tr valign="top" >
	<td>
	{tblfields}
	</td>

	</tr>
	</tbody>
	</table>
	</fieldset>
	

		<p align="center" >
		<input type="checkbox" id="cbwrkpmtdetail" onClick={(e)=>{setCbwrkpmtdetail({checked:e.target.checked});}} /><label htmlFor="cbwrkpmtdetail" className="hand" >show Work Permit Id# {wptapp.WORK_PERMIT_ID} details</label>
		</p>
		
		
		{/*
		first_name, status, date_issue, expire_date, updated_by, updated_date, approved_by, approved_date, card_no, ActivityDateTime, collectDate, collectPerson
		*/}
		
		{
		AD_USER=="ajones" && <>
			{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{!dowait.show && 
				<table align="center" className="customers" >
				<thead>
				<tr>
					<th align="left">db</th>
					<th align="left">first_name</th>
					<th align="left">status</th>
					<th align="left">date_issue</th>
					<th align="left">expire_date</th>
					<th align="left">updated_by</th>
					<th align="left">updated_date</th>
					<th align="left">approved_by</th>
					<th align="left">approved_date</th>
					<th align="left">card_no</th>

					<th align="left">ActivityDateTime</th>
					<th align="left">collectDate</th>
					<th align="left">collectPerson</th>
				
				</tr>
				</thead>
				<tbody>
				<tr><td align="center" >APS:</td>{tblwrkpmt.aps}</tr>
				<tr><td align="center" >IPM:</td>{tblwrkpmt.ipm}</tr>
				</tbody>
				</table>
			}
		</>
		}
	
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >
	{
		sessionStorage.getItem("AD_USER")=="ajones" && 
		<><a href="#" onClick={(e)=>{clickworkpermit(e);}} ><img src="img/addbutton.png" border="0" /></a>&nbsp;&nbsp;</>
	}
	Work Permits Matching Person's Name
	</p>
	
	<table align='center' className='customers' style={{width:"90%",marginBottom:"24px"}} id="tblpersonworkpermits"  >
	<thead>
	<tr>
		<th>#</th>
		<th>Work<br/>Pmt. Id</th>
		<th>create<br/>date</th>
		<th>Immigr.<br/>Ref. #</th>
		<th>Employee</th>
		<th>Type</th>
		<th>Status</th>
		<th>Issue<br/>date</th>
		<th>Expire<br/>date</th>
		<th>Occupation</th>
		<th>Employer</th>
		<th>Card<br/>printed</th>
	</tr>
	</thead>
	<tbody>
	{tblworkpermits}
	</tbody>
	</table>
	
	{
	SUP_PVG>0 && 	<>
	<div align="center" style={{marginBottom:"24px"}} >
		<button id="btnsearchvchrs" onClick={(e)=>{searchworkervchrs(e);}}   className="button" >search receipts for {wptapp.FIRST_NAME}</button>
	</div>
	<div align="center" id="divdocsearchdate"   className="hidden" >
		you can choose a date then search again: <input type="date" value={docsearchcrit.date} onChange={(e)=>{doSetDocsearchcrit(e.target.value); }}  />
	</div>
	</>
	}
	{
	SUP_PVG>0 && tbldocno.length>0 &&
	<div align="center" style={{marginBottom:"24px"}} >
		<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Receipts Matching Date Received (close range), Worker First Name or Immig. Ref #</p>
		
		<table align='center' className='customers' style={{width:"90%",marginBottom:"24px"}} id="tbldocnos"  >
		<thead>
		<tr>
			<th>#</th>
			<th>Created</th>
			<th>Doc. #</th>
			<th>Amount</th>
			<th>Paid</th>
			<th>Account</th>
			<th>State</th>
			<th>Comment</th>
		</tr>
		</thead>
		<tbody>
		{tbldocno}
		</tbody>
		</table>
	</div>
	}
	


</div>	

<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button">&times;</span>
        <div  id='modalsmtext' >
		<div align="left" >
		please note the password requirements:
		</div>
		<table align="center">
		<tbody>
		<tr>
			<td align="right" >enter password:</td>
		</tr>
		<tr>
			<td align="right" >re-enter password:</td>
		</tr>
		<tr>
			<td align="right" >&nbsp;</td>
			<td align="left" ><button className="button" id="btnpwd" style={{visibility:"hidden"}}  >save the password</button></td>
		</tr>
		</tbody>
		</table>
		
		</div>
		
    </div>
</div>	


<div id="snackbar">&nbsp;</div>
    
	
	</>
  );
  


};


export default RenderLcrprocess;